/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 16:41:54
 * @LastEditTime: 2019-12-19 10:53:49
 * @LastEditTime: 2019-09-09 11:43:43
 * @LastEditors: Please set LastEditors
 */

export default {
  v5: {
    select_files_to_upload: 'Select files to upload',
    my_video_shorts: 'MIS VIDEOS CORTOS',
    see_more: 'VER MÁS',
    no_shorts_found: 'No se encontraron Shorts',
    shorts: 'Shorts',
    general_information: 'Información general',
    gamification: 'Gamificación',
    click_to_select_files: 'Haga clic para seleccionar archivos',
    selected_files: 'Archivos seleccionados',
    uploaded: 'Subido',
    failed: 'Fallido',
    system_will_automatically_analyze_and_select_the_most_relevant:
      'El sistema analizará automáticamente y seleccionará los documentos más relevantes de la biblioteca de su organización según los requisitos de contenido.',
    select_from_library: ' Seleccionar de la biblioteca',
    search_document: 'Buscar documentos...',
    selected: 'Seleccionado',
    loading_documents: 'Cargando documentos...',
    review_generated_content: 'Revisar contenido generado',
    confirm_and_replace_content: 'Confirmar y reemplazar contenido',
    the_generate_content_will_replace:
      'El contenido generado reemplazará el texto existente en las páginas seleccionadas. Si no desea aplicar estos cambios, puede regresar al paso anterior.',
    pages_to_be_updated: 'Páginas a actualizar',
    generated_revisions: 'Revisiones generadas',
    lesson_preview: 'Vista previa de la lección',
    create_new_folder: 'Crear nueva carpeta',
    rename_item: 'Renombrar elemento',
    enter_folder_name: 'Ingrese el nombre de la carpeta:',
    enter_new_name: 'Ingrese un nuevo nombre:',
    folder_name: 'Nombre de la carpeta:',
    new_name: 'Nuevo nombre',
    move_items: 'Mover elementos',
    copy_items: 'Copiar elementos',
    move_here: 'Mover aquí',
    copy_here: 'Copiar aquí',
    select_destination_library_and_folder:
      'Seleccione la biblioteca y carpeta de destino:',
    items_selected: 'Elementos seleccionados',
    version: 'Versión',
    modified_by: 'Modificado por',
    size: 'Tamaño',
    restore: 'Restaurar',
    are_you_sure_you_want_to_restore_this_version:
      '¿Está seguro de que desea restaurar esta versión?',
    this_will_replce_the_current_version_with_the_selected_one:
      'Esto reemplazará la versión actual con la seleccionada.',
    restore_this_version: 'Restaurar esta versión',
    restore_not_available: 'Restauración no disponible',
    version_history: 'Historial de versiones:',
    by_making_items_public:
      'Al hacer públicos los elementos, serán visibles para todos. Revise los términos y condiciones antes de continuar.',
    the_selected_items_will_be_copied:
      'Los elementos seleccionados se copiarán a su biblioteca pública y serán visibles para todos.',
    the_selected_items_will_be_copied_to_org:
      'Los elementos seleccionados se copiarán a la biblioteca de su organización y serán visibles para todos los miembros de la organización.',
    the_selected_items_will_be_copied_to_your_private:
      'Los elementos seleccionados se copiarán a su biblioteca privada y solo serán visibles para usted.',
    loading_organization: 'Cargando usuarios de la organización...',
    click_download_to_view: 'Haga clic en "Descargar" para ver',
    archive_file: 'Archivo de archivo',
    no_preview_available: 'Vista previa no disponible',
    audit_report: 'Informe de auditoría',
    audit_type: 'Tipo de acción',
    i_agree_to_the_terms_and_conditions: 'Acepto los términos y condiciones.',
    this_file_is_indexed_for_ai: 'Este archivo está indexado para IA.',
    file_is_not_indexed_for_ai: 'Archivo no indexado para IA.',
    no_users_found: 'No se encontraron usuarios',
    no_users_available: 'No hay usuarios disponibles',
    add_people: 'Agregar personas',
    people: 'Personas',
    access_type: 'Tipo de acceso',
    no_group_found: 'No se encontraron grupos',
    add_group: 'Agregar grupos',
    groups: 'Grupos',
    users_top: 'usuario(s)',
    confirm_delete: 'Confirmar eliminación',
    do_you_want_remove: '¿Desea eliminar',
    form_this_documents_permissions: 'de los permisos de este documento?',
    no_users_found_in_this_group: 'No se encontraron usuarios en este grupo',
    add_selected_users: 'Agregar usuarios seleccionados',
    choose_users_from_the_list: 'Seleccione usuarios de la lista',
    selected_users: 'Usuarios seleccionados',
    archived: 'Archivado',
    request_approval: 'Solicitar aprobación',
    document_in_review: 'Documento en revisión',
    approve: 'Aprobar',
    reject: 'Rechazar',
    comment: 'Comentario:',
    enter_your_commit: 'Ingrese su comentario...',
    confirm_cancel: 'Confirmar cancelación',
    upload_3d_zip: 'Subir ZIP 3D',
    delete_items: 'Eliminar elementos',
    video_upload_request: 'Solicitud de carga de video',
    reject_video: 'Rechazar video',
    enter_rejection_reason: 'Ingrese la razón del rechazo...',
    please_provide_a_reason_for_reejection_this_video:
      'Proporcione un motivo para rechazar este video:',
    generate_trivia_with_ai: 'Generar trivia con IA',
    select_category: 'Seleccionar categoría:',
    number_of_question: 'Número de preguntas',
    generated_questions: 'Preguntas generadas',
    this_will_clear_all_generate_question:
      'Esto borrará todas las preguntas generadas. ¿Continuar?',
    sure_delete: '¿Está seguro de que desea eliminar?',
    delete_this_question: '¿Está seguro de que desea eliminar esta pregunta?',
    loading_quiz: 'Cargando cuestionario...',
    creteing_file: 'Creando archivo',
    opening_desktop_app: 'Abriendo aplicación de escritorio',
    this_folder_is_empty: 'Esta carpeta está vacía',
    select_a_competition: 'Seleccionar una competencia...',
    activity_badges: 'Insignias de actividad',
    awarded_every_badges:
      'Otorgadas cada 4, 8, 16, 32, 64, 128, 256, 512 inicios de sesión',
    learning_badges: 'Insignias de aprendizaje',
    awarded_every_courses:
      'Otorgadas cada 1, 4, 8, 16, 32, 64, 128 cursos completados',
    test_badges: 'Insignias de prueba',
    awarded_every_passes_tests:
      'Otorgadas cada 2, 4, 8, 16, 32, 64, 128, 256 pruebas aprobadas',
    assignment_badges: 'Insignias de tareas',
    awarded_every_passed_assignments:
      'Otorgadas cada 1, 2, 4, 8, 16, 32, 64, 128 tareas aprobadas',
    perfectionism_badges: 'Insignias de perfeccionismo',
    awarded_every_assignments_with_scrore:
      'Otorgadas cada 1, 2, 4, 8, 16, 32, 64, 128 pruebas o tareas con puntuación de 90%+',
    communication_badges: 'Insignias de comunicación',
    awarded_every_topics_or_comments:
      'Otorgadas cada 2, 4, 8, 16, 32, 64, 128, 256 temas o comentarios',
    certification_badges: 'Insignias de certificación',
    awarded_every_certificates:
      'Otorgadas cada 1, 2, 4, 8, 16, 32, 64, 128 certificados',
    level_name: 'Nombre del nivel',
    delete_competition: 'Eliminar competencia',
    this_week: 'Esta semana',
    this_year: 'Este año',
    make_organization: 'Hacer organización',
    no_results_found: 'No se encontraron resultados para',
    no_items_available: 'No hay elementos disponibles',
    help_video: 'Videos de ayuda',
    select_a_video_from_the_list:
      'Seleccione un video de la lista para comenzar a aprender'
  },
  v4: {
    upload_another_file: 'Upload another file',
    all_files_uploaded: 'All files uploaded',
    upload_and_submit: 'Upload & Submit',
    drop_files: 'Suelta los archivos y selecciona dónde subirlos.',
    duplicate_lessoon: 'La lección ya está presente en el curso',
    skill_rule_title: 'Por favor, ingresa el título del viaje de habilidades',
    imageCreatorTitle: 'Creador de Imágenes',
    isTranslated: 'Traducido',
    translationCourseDesc:
      'Traducir este curso puede tardar unos minutos. ¡Gracias por tu paciencia!',
    translateCourseTip:
      'Crea un curso traducido que puedas modificar de forma independiente del original, incluyendo todas las lecciones y páginas.',
    translateModalBtn: 'Traducir',
    translationSuccess: 'El curso "<0/>" se ha traducido exitosamente.',
    translatingCourse: 'Traduciendo curso...',
    translateModalTitle: 'Traducir Curso',
    translateSelectLang: 'Selecciona idioma',
    fileDeleteconfirm:
      '¿Estás seguro de que deseas eliminar este archivo? Esta acción no se puede deshacer.',
    fileDeleteMessage: 'Archivo eliminado exitosamente.',
    fileDeleteFailedMessage: '¡No se pudo eliminar el archivo!',
    fileDelete: 'Eliminar este archivo.',
    certificate_save_btn: 'Agregar certificado a ',
    maze_path_info: '¡No hay rutas disponibles en el gráfico!',
    file_size_mb: '¡El tamaño del archivo debe ser menor a 25 MB!',
    reports: {
      products: 'Productos',
      users: 'Usuarios',
      ph_username: 'Buscar usuario por nombre de usuario',
      ph_id: 'Buscar usuario por ID',
      ph_email: 'Buscar usuario por correo electrónico'
    },
    select_upload_section_id: 'Se requiere archivo para la sección',
    tags_all: 'Todos',
    delete_file_confirm: '¿Estás seguro de que deseas eliminar este archivo?',
    delete_file_title: 'Eliminar archivo',
    tooltip_publish: 'Publicar el curso con la opción seleccionada',
    tooltip_save: 'Guardar curso con los cambios actuales',
    tooltip_next: 'Ir al siguiente ajuste del curso',
    tooltip_finish: 'Finalizar y guardar los cambios actuales',
    stories_modal: {
      title_upload: 'Subir historias',
      title_update: 'Actualizar historias',
      title_audio: 'Archivo de audio de la historia',
      btn_upload: 'Subir',
      btn_update: 'Actualizar',
      btn_close: 'Cerrar',
      btn_cancel: 'Cancelar',
      lbl_cover: 'Imagen de portada de la historia',
      rule_cover: '¡Por favor sube una portada para el audio de la historia!',
      lbl_title: 'Título del audio de la historia',
      rule_title: '¡Ingresa el título del audio de la historia!',
      lbl_description: 'Descripción del audio de la historia',
      rule_description: '¡Ingresa una descripción del audio de la historia!',
      lbl_file: 'Subir archivo de audio de la historia',
      rule_file: '¡Por favor sube el archivo de audio de la historia!',
      rule_file_type: '¡Por favor sube un archivo de audio válido!',
      lbl_select_file: 'Seleccionar archivo de audio de la historia',
      msg_valid_file: '¡Selecciona un archivo de audio válido!',
      msg_success: 'Archivo de audio subido exitosamente',
      msg_failed: '¡No se pudieron asignar datos multimedia!',
      msg_error: '¡Error al subir el archivo!'
    },
    audio_modal: {
      title_upload: 'Subir',
      title_update: 'Actualizar',
      title_audio: 'Archivo de audio',
      btn_upload: 'Subir',
      btn_update: 'Actualizar',
      btn_close: 'Cerrar',
      btn_cancel: 'Cancelar',
      lbl_cover: 'Imagen de portada del audio',
      rule_cover: '¡Por favor sube una portada para el audio!',
      lbl_title: 'Título del audio',
      rule_title: '¡Ingresa el título del audio!',
      lbl_description: 'Descripción del audio',
      rule_description: '¡Ingresa una descripción del audio!',
      lbl_file: 'Subir archivo de audio',
      rule_file: '¡Por favor sube un archivo de audio!',
      rule_file_type: '¡Por favor sube un archivo de audio válido!',
      lbl_select_file: 'Seleccionar archivo de audio',
      msg_valid_file: '¡Selecciona un archivo de audio válido!',
      msg_success: 'Archivo de audio subido exitosamente',
      msg_failed: '¡No se pudieron asignar datos multimedia!',
      msg_error: '¡Error al subir el archivo!'
    },
    info_episode: 'Imagen de portada del episodio.',
    btn_delete_episode: 'Eliminar este episodio del pódcast.',
    btn_edit_marketplace: 'Editar los detalles del marketplace.',
    btn_save_marketplace: 'Guardar los cambios actuales.',
    btn_ai_podcast: 'Crear episodio de pódcast con IA.',
    btn_upload_podcast: 'Subir tu propio episodio de pódcast.',
    attach_file: 'Sube archivos para compartir más contenido con tu audiencia',
    fileDownload: 'Descargar este archivo.',
    singleEpishode: 'Episodio',
    podcast_music: 'pódcast, música e historias',
    publishHeader: 'Publicar pódcast, música e historias',
    editHeader: 'Editar pódcast, música e historias',
    createHeader: 'Crear pódcast, música e historias',
    marketplaceHeader:
      'Detalles del marketplace de pódcast, música e historias',
    message_marketplace: '¡Por favor completa el formulario del marketplace!',
    create_podcast_live: 'Pódcast y música en vivo',
    create_podcast_custom: 'Pódcast y música personalizados',
    create_podcast_stories: 'Historias',
    ai_Assisted_podcast_reation: 'Pódcast y música asistidos por IA',
    publishTitle: 'Publica pódcast, música e historias para el público.',
    customButton: 'Crear personalizado',
    customTitle: 'Guardar los cambios del pódcast.',
    updateButton: 'Actualizar',
    createButton: 'Crear',
    createNewButton: 'Crear nuevo',
    updateTitle:
      'Actualizar detalles del pódcast, música e historias actuales.',
    createTitle: 'Crear nuevo pódcast, música e historias',
    createNewTitle:
      'Se creará un nuevo pódcast, música e historias con los nuevos datos.',
    podcastTitle: 'Lista de episodios',
    podcastStoryTitle: 'Lista de episodios de historias',
    podcastToolTipTitle: 'Lista de episodios del pódcast',
    uploadAudio: 'Subir',
    aiAudio: 'Audio IA',
    emptyPodcast: 'Aún no hay grabaciones de pódcast, música o historias.',
    emptyStoriesPodcast: 'Todavía no se han añadido historias.',
    emptyCreatePodcast: 'Crea un pódcast antes de añadir audios.',
    playPodcast: 'Reproducir el pódcast, música e historias seleccionados.',
    pausePodcast: 'Pausar el pódcast, música e historias seleccionados.',
    selectPodcast: 'Seleccionar este pódcast, música e historias.',
    downloadPodcast: 'Descargar este audio.',
    uploadAudioFile: 'Sube un nuevo audio y reemplaza el actual.',
    deleteConfirm: '¿Estás seguro de que deseas eliminar este audio?',
    roomName: 'Nombre del pódcast',
    addGuestTitle: 'AGREGAR INVITADO',
    showTime: 'Hora del show',
    startTime: 'Hora de inicio',
    endTime: 'Hora de fin',
    erorMsgImg: 'Selecciona una imagen válida.',
    failedMsgImg: 'Error al cargar la imagen. ¡Intenta de nuevo!',
    failedMsgUpload: '¡Error al subir la imagen de portada!',
    btnCoverUpload: 'Subir portada',
    is_private: 'Privado',
    to_attach: 'Adjuntar archivo',
    file_attached: 'Archivo adjunto',
    main_event: 'Evento principal',
    event: 'Eventos',
    upload_pdf: 'Subir PDF',
    portrait: 'Vertical',
    landscape: 'Horizontal',
    import_from_library: 'Importar texto desde la biblioteca multimedia',
    question_answer_ai: 'IA de Preguntas/Respuestas',
    take_maze: 'INICIAR MetaMaze',
    training: 'Entrenamiento',
    select_transcribe_locale: 'Selecciona el idioma para transcribir',
    transcribe_limit: 'Por favor, ingresa los minutos a transcribir',
    not_complete: 'La información del Marketplace no está completa',
    complete: 'La información del Marketplace está completa',
    not_admin:
      'Se requieren privilegios de administrador para publicar en el Marketplace',
    no_course:
      'Ingresa el título y selecciona una imagen para habilitar el Marketplace',
    scorm_not_complete:
      'Ingresa el título y selecciona una imagen para subir el archivo SCORM',
    not_found_maze: 'MetaMaze no encontrado',
    email_require: 'Se requieren correos electrónicos',
    poll_required: 'Se requieren datos de la encuesta',
    alert: '¡Alerta!',
    warning: '¡Advertencia!',
    ok: 'Aceptar',
    cancel: 'Cancelar',
    done: 'Hecho',
    insert: 'Insertar',
    private: 'Privado',
    public: 'Público',
    no_connection: 'Conexión a internet perdida',
    switch: 'Cambiar',
    share_screen: 'Compartir pantalla',
    stop_share_screen: 'Detener compartir pantalla',
    share_screen_with_camera: 'Compartir pantalla con cámara',
    stop_share_screen_with_camera: 'Detener compartir pantalla con cámara',
    camera_on: 'Cámara encendida',
    camera_off: 'Cámara apagada',
    mic_on: 'Activar micrófono',
    mic_off: 'Silenciar micrófono',
    fullscreen: 'Pantalla completa',
    live_now: 'En vivo',
    schedule_on: 'Programado para',
    organisations: 'Organizaciones',
    org_groups: 'Grupos organizacionales',
    specific_user: 'Usuario específico',
    gif: 'GIF',
    unavailable: 'No disponible',
    yes: 'Sí',
    no: 'No',
    event_duration_message: 'Máximo 300 minutos (5 horas)',
    send_email: 'Enviar notificación por correo electrónico',
    admin_only: 'Solo para administradores',
    join: 'Unirse',
    leave: 'Salir',
    share: 'Compartir',
    share_text:
      'Escribe la dirección de correo electrónico de la persona con la que deseas compartir este archivo.',
    share_text_title: 'Compartir PDF',
    share_text_title_txt: 'Compartir texto',
    select_users: 'Seleccionar usuarios',
    delete: 'Eliminar',
    attachment_event: 'Archivos adjuntos del evento:',
    transcribe_limit: 'Minutos de transcripción',
    monthly_transcribe: 'Límite mensual de transcripción:',
    enable_ai: 'Activar IA:',
    enable_maze: 'Activar MetaMaze:',
    media_service: 'Servicio de medios',
    allow_others: 'Permitir que otros editen',
    join_breakout_room: 'Unirse a sala de grupos',
    bio: 'Biografía',
    linkedin: 'LinkedIn',
    select_org_report:
      'Busca y selecciona una organización para generar el reporte.',
    org_image_not_found: 'Imagen no encontrada',
    insert_text: 'Insertar texto',
    insert_question_answer: 'IA de Preguntas/Respuestas',
    modal_title2: 'Galería de textos',
    my_text_library: 'Mi biblioteca de textos',
    ai: 'IA',
    public_text_library: 'Biblioteca pública de textos',
    organization_text_library: 'Biblioteca organizacional de textos',
    no_transcribed_text: 'No se encontraron textos transcritos',
    public_text_not_found: 'No se encontró texto transcrito público',
    org_text_not_found: 'No se encontró texto transcrito de la organización',
    org_video_not_found: 'Video no encontrado',
    canva: 'Hazlo con Canva',
    canva_open: 'Haz clic aquí para abrir el editor de Canva.',
    pdf: 'PDF',
    txt: 'TEXTO',
    human: 'Premium',
    shared_file: 'El archivo se ha compartido correctamente.',
    error_shared_file:
      'Hubo un problema al compartir el archivo. Intenta nuevamente.',
    publish: 'Publicar',
    maze_scenes: 'Escenas de MetaMaze',
    pexel_images: 'Imágenes de Pexel',
    group: 'Grupo',
    group_name: 'Nombre del grupo',
    select_group: 'Seleccionar grupo',
    search_maze: 'Buscar MetaMaze',
    hosts: 'Anfitriones',
    avg_score: 'Porcentaje promedio',
    maze_report: 'Informe de Maze',
    maze_view: 'Vista de Maze',
    title_maze: 'MetaMaze',
    author: 'Autor',
    match: 'Coincidencia de ruta',
    preview_mazeTitle: 'Título: ',
    other: 'Otro',
    total: 'TOTAL',
    report_course: 'CURSO',
    report_courses: 'CURSOS',
    report_event: 'EVENTO',
    report_events: 'EVENTOS',
    report_maze: 'MAZE',
    report_personalize_learning: 'APRENDIZAJE PERSONALIZADO',
    report_live_assessment: 'EVALUACIÓN EN VIVO',
    report_live_assessments: 'EVALUACIONES EN VIVO',
    report_skill_journey: 'RECORRIDO DE HABILIDADES',
    skill_journey: 'Recorrido de habilidades',
    skill_journeys: 'Recorridos de habilidades',
    date: 'FECHA: ',
    search_people: 'Buscar personas',
    passed: 'APROBADO',
    failed: 'REPROBADO',
    item: 'ELEMENTO',
    type: 'TIPO',
    minimum_pass_score: 'PUNTAJE MÍNIMO PARA APROBAR',
    resources_count: 'CANTIDAD DE RECURSOS',
    back: 'REGRESAR',
    resources: 'RECURSOS',
    time_spent: 'TIEMPO EMPLEADO (MINUTOS)',
    detail: 'DETALLES',
    watched_time_mins: 'TIEMPO VISUALIZADO (MINUTOS)',
    personalize_learning: 'Aprendizaje personalizado',
    result: 'Resultado',
    assessment_title: 'Título',
    marketPlace_graph: 'Gráfica del Marketplace',
    attachments: 'Archivos adjuntos adicionales',
    new_scorm_course: 'Subir un nuevo curso SCORM',
    upload_scorm_course: 'Subir curso SCORM',
    new_maze: 'Crear un nuevo MetaMaze',
    new_skill_journey: 'Crear un Recorrido de Habilidades',
    tags_scorm: 'SCORM',
    tags_skillJourney: 'Recorrido de Habilidades',
    new_discussion_room: 'Crear un nuevo pódcast',
    title: '¿Qué quieres hacer hoy?',
    build_course: 'Crear mi curso',
    live_broadcast: 'Transmisión en vivo',
    invite_users: 'Invitar usuarios a mi organización',
    build_voice_over: 'Crear mi narración',
    view_reports: 'Ver informes',
    upload_media: 'Subir mis medios o trabajos y compartirlos',
    main_menu: 'Menú principal',
    get_started: 'COMENZAR',
    search_group: 'Buscar grupo de la organización',
    ai_course: 'Curso de IA',
    search_user: 'Buscar nombre de la empresa',
    no_maze: 'Actualmente no hay MetaMaze disponibles.',
    conference_event_title: 'Eventos de conferencia',
    conference_event_subTitle: 'Eventos de conferencia finalizados',
    conference_event: 'Actualmente no hay eventos de conferencia.',
    no_skill: 'Actualmente no hay recorridos de habilidades.',
    no_podcast: 'Actualmente no hay pódcast.',
    maze_channel: 'MetaMaze',
    past_live_assessment: 'Evaluaciones en vivo anteriores',
    no_live_assessment: 'Actualmente no hay evaluaciones en vivo.',
    enrolled_courses: 'Cursos',
    my_video_channel: 'Mis canales de video',
    enrolled_liveEvents: 'Eventos en vivo',
    sharebot: 'Sharebot',
    selected_language: 'Idioma seleccionado',
    shareSphere_game: 'Juego ShareSphere',
    maze: 'MetaMaze',
    skill: 'Recorrido de Habilidades',
    channel: 'Canal',
    order: 'Orden',
    is_record: 'Grabar',
    no_maze_found: 'No se encontró ningún MetaMaze.',
    maze_self_limit_reached:
      'Se alcanzó el límite de autoevaluaciones en MetaMaze.',
    metamaze_two_times: 'Ya realizaste este MetaMaze 2 veces.',
    metamaze_two_times_no_result:
      'Ya realizaste este MetaMaze 2 veces. Tu resultado no se registrará si completas esta autoevaluación más de dos veces.',
    scorm_zip: 'SCORM ZIP',
    pass_score: 'Puntaje mínimo para aprobar',
    organization: 'Por favor selecciona una organización',
    pass_score_mark: 'Ingresa una puntuación entre 1 y 100',
    maze_cloning_success: '¡MetaMaze "<0/>" se clonó exitosamente!',
    create_certificate: 'Crear un certificado',
    create_badge: 'Crear una insignia',
    certificate_added: 'Certificado agregado.',
    badge_added: 'Insignia agregada.',
    certificate_warning:
      '¡No podrás editar el certificado/insignia una vez publicado!',
    created_course_plan:
      'Edita y publica tu curso creado y programa eventos en vivo',
    market_place_space: 'Mercado',
    select_course_language: 'Seleccionar idioma (opcional)',
    select_language: 'Seleccionar idioma',
    file_upload: 'Subida de archivos',
    text: 'Escribe el texto aquí…',
    attempts_count: 'Número de intentos permitidos para el usuario',
    no_of_people_placeholder: 'Cantidad de personas',
    back_to_maze: 'Volver al escenario de MetaMaze',
    edit_maze: 'Editar Maze',
    wait: 'Espera...',
    retry: 'Reintentar',
    publish_scorm_course: 'Publica tu curso SCORM',
    publish_maze: 'Publica tu MetaMaze',
    import: 'Importar elementos',
    answer_correct: 'Elige la respuesta correcta',
    author_name: 'Ingresa el nombre del autor',
    select_category: 'Selecciona una categoría',
    course_outline: 'Ingresa el esquema del curso',
    course_obj: 'Ingresa los objetivos del curso',
    course_description: 'Ingresa la descripción del curso',
    maze_outline: 'Ingresa el esquema del laberinto',
    maze_obj: 'Ingresa los objetivos del laberinto',
    maze_description: 'Ingresa la descripción del laberinto',
    lessons: 'Ingresa el número de lecciones',
    user_email_require: 'Se requiere el correo electrónico del usuario',
    team_size: 'Se requiere el tamaño del equipo',
    enter_price: 'Ingresa un precio (5 o más)',
    input_title_maze: 'Ingresa el título del laberinto',
    trainer_bio: 'Ingresa la biografía del instructor',
    trainer_linkedin: 'Ingresa el LinkedIn del instructor',
    error_video: 'Ingresa el número de videos',
    input_video_link: 'Ingresa el enlace del video',
    number_of_video: 'número de videos',
    number_of_lessions: 'número de lecciones',
    no_of_people_in_conference: '¿Cuántas personas hay en la conferencia?',
    transcribe_settings: 'Configuración de transcripción',
    transcribe: 'Transcribir',
    cloning_maze: 'Clonando MetaMaze...',
    id_number: 'Número de identificación',
    timezone: 'Zona horaria',
    edit_maze: 'Editar',
    delete_maze: 'Eliminar',
    view_maze: 'Ver',
    create_metamaze: 'Crear un MetaMaze',
    metamaze_scenario: 'Escenario de MetaMaze',
    publish_metamaze: 'Configuración de publicación',
    search_result: 'Resultados de búsqueda:',
    search_for: 'Buscar',
    search_no_result: '- ¡No hay resultados disponibles!',
    channel_no_available: '¡No hay canales disponibles!',
    this_card: 'Esta es una tarjeta',
    course_no_available: '¡No hay cursos disponibles!',
    exit_fullscreen: 'Salir de pantalla completa',
    bg_image: 'Imagen de fondo',
    introduction: 'Introducción',
    summary: 'Resumen',
    generate_introduction: 'Generar introducción',
    generate_summary: 'Generar resumen',
    bullet_points: 'Puntos clave',
    title_simulation: 'Ingresa el nombre de la simulación',
    view_generated_images: 'Ver imágenes generadas',
    image_transparency: 'Transparencia de imagen',
    template_bg_color: 'Color de fondo de plantilla',
    select_template_layout: 'Selecciona un diseño de plantilla',
    reload_template: '(Recargar plantillas)',
    are_you_sure_want_close: '¿Estás seguro de que deseas cerrar?',
    all_your_changes_will_be_lost: 'Todos tus cambios se perderán.',
    please_checked_before_generated_video:
      'Por favor, asegúrate de que se han marcado todas las condiciones antes de generar el video.',
    voice_must_be_selected: 'Debes seleccionar una voz',
    avatar_must_be_selected: 'Debes seleccionar una imagen de avatar.',
    maximum_five_slides_try_again:
      'Error al extraer imágenes del archivo. Asegúrate de que haya un máximo de 5 diapositivas y que cada una tenga notas. ¡Intenta nuevamente!',
    back_to_upload: 'Volver a subir',
    uploading_file_to_server: 'Subiendo el archivo al servidor',
    extracting_images_from_your_file: 'Extrayendo imágenes de tu archivo',
    upload_your_ppt_or_drag: 'Sube tu presentación (.PPTX) o arrástrala aquí.',
    maximum_five_slides_error:
      'Asegúrate de que tu archivo PowerPoint tenga como máximo 5 diapositivas con notas. De lo contrario, ocurrirá un error.',
    number_of_questions_generated: 'Número de preguntas a generar',
    quiz_page_this_cannot_be_done:
      '¿Estás seguro de que deseas agregar el cuestionario a esta página? Esto no se puede deshacer.',
    confirm_selection: 'Confirmar selección',
    select_quiz_page: 'Seleccionar página del cuestionario',
    lesson_do_you_want_add_this_quiz:
      '¿En qué parte de la lección deseas agregar este cuestionario?',
    beginning_of_lesson: 'Al inicio de la lección',
    end_of_lesson: 'Al final de la lección',
    currently_active_page: 'Página activa actualmente',
    finish: 'Finalizar',
    upload_selection_file: 'Subir archivo de sección',
    general_quiz: 'Cuestionario general',
    manage_sequence: 'Administrar secuencia',
    save_sequence: 'Guardar secuencia',
    new: 'Nuevo',
    in_progress: 'En progreso',
    recommended_course: 'Curso recomendado',
    up_coming: 'Próximo',
    past_live: 'Transmisiones pasadas',
    input_your_channel_name: '¡Ingresa el nombre de tu canal!',
    organization_place: 'Mercado de la organización',
    marketplace_report: 'Reporte del mercado',
    story_writing: 'Escritura de historias',
    Ai_quiz: 'Cuestionario con IA',
    generate_quiz: 'Generar cuestionario',
    create_story: 'Crear historia',
    change_layout_page: 'Estás a punto de cambiar el diseño de esta página.',
    change_layout_message:
      'Ten en cuenta que solo se conservarán el texto, las imágenes, el fondo y el logotipo. Todos los demás elementos serán eliminados.',
    reviews: 'Reseñas',
    tab_attachments: 'Adjuntos',
    zoom_in: 'Acercar',
    zoom_out: 'Alejar',
    zoom_reset: 'Restablecer zoom',
    no_attachment: 'No hay archivos adjuntos.',
    select_upload_simulation: 'Selecciona o sube una simulación.',
    quiz_updated_successfully: '¡Cuestionario actualizado con éxito!',
    quizes: 'Cuestionarios',
    trivia: 'Trivia',
    closing: 'Cerrando...',
    products: 'Productos',
    ask_questions: 'Haz tu pregunta aquí...',
    course_information: 'Información del curso',
    course_assistance: 'Asistencia para el creador del curso',
    go_back: 'Regresar',
    ai_generate_content_progress: 'Progreso generando contenido',
    view_generate_content: 'Ver contenido generado',
    generate_error: '¡Error al generar!',
    confirm_creating_course:
      '¿Deseas confirmar la creación del curso con este contenido?',
    generate_content_automatically:
      'Esto agregará automáticamente todo el contenido generado como lecciones y páginas al curso.',
    quiz_created_successfully: '¡Cuestionario creado exitosamente!',
    create_quiz: 'Crear cuestionario',
    quiz_setting: 'Configuración del cuestionario',
    please_fill_quiz_setting:
      '* Por favor completa todos los campos en la configuración del cuestionario',
    question_list: 'Lista de preguntas',
    add_quiz_to_page: 'Agregar cuestionario a la página',
    form_create_question: 'Formulario para crear pregunta',
    user_information_updated: '¡Información del usuario actualizada!',
    your_stripe_activete_to_continue:
      'Tu cuenta de Stripe no está activa. Conéctala o actívala para continuar.',
    connect_tripe: 'Conectar Stripe',
    certificate_sent_sucessfully:
      'Certificado enviado exitosamente a tu correo.',
    error_try_again: 'Error. ¡Inténtalo de nuevo!',
    error_delete_channel: 'Error al eliminar el canal.',
    error_update_sub: 'Error al actualizar la suscripción.',
    end_time_cannot_start:
      'La hora de finalización no puede ser anterior al inicio.',
    start_date_time_interval: '¡Se requiere la fecha y hora de inicio!',
    podcast_updated_successful: 'Podcast actualizado exitosamente.',
    podcast_created_successful: 'Podcast creado exitosamente.',
    podcast_published_successful: 'Podcast publicado exitosamente.',
    podcast_cover_updated: 'Portada del podcast actualizada.',
    new_podcast_details:
      'Se creará un nuevo podcast con los datos ingresados basados en el actual.',
    current_update_podcast: 'Actualizar el podcast actual, música e historias.',
    create_new_podcast: 'Crear nuevo podcast',
    publish_podcast_public_view: 'Publicar el podcast para vista pública.',
    only_allowed_twenty_five_email: 'Solo se permiten 25 correos electrónicos.',
    only_allowed_five_email: 'Solo se permiten 5 correos electrónicos.',
    cover_is_required: 'Se requiere una portada.',
    topic_is_required: 'Se requiere un tema.',
    delete_schedule: 'Eliminar programación',
    make_as_coaching: 'Marcar como disponible para coaching',
    manage_category: 'Administrar categoría',
    threshold: 'Umbral',
    threshold_popup:
      'Porcentaje (%) que activa la recomendación para una categoría específica.',
    list_of_catagory: 'Lista de categorías',
    category_name: 'Nombre de la categoría',
    category_threshold: 'Umbral de la categoría',
    play_game: 'Jugar',
    switching_organization: 'Cambiando organización...',
    coaching_session: 'Sesión de coaching',
    required_channel_id: '¡Se requiere ID del canal!',
    error_occured_try_again: 'Ocurrió un error. ¡Inténtalo de nuevo!',
    please_complete_marketplace_form:
      '¡Completa el formulario del marketplace!',
    upload_file_corrupt: 'El archivo cargado está dañado.',
    course_not_published: '¡Este curso aún no ha sido publicado!',
    error_request: 'Error en la solicitud. ¡Inténtalo de nuevo!',
    skill_request: '¡Completa los campos obligatorios!',
    error_occured: 'Ocurrió un error. ¡Inténtalo otra vez!',
    show_time: 'Mostrar hora',
    start_time: 'Hora de inicio',
    end_time: 'Hora de fin',
    room_name: 'Nombre del podcast',
    add_guest_speaker: 'Agregar ponente invitado',
    cover_picture: 'Imagen de portada',
    guest_speaker: 'Ponente invitado',
    see_more: 'Ver más',
    see_less: 'Ver menos',
    background: 'Fondo',
    icon: 'Ícono',
    icon_size: 'Tamaño del ícono',
    icon_color: 'Color del ícono',
    only_text: 'Solo texto',
    change_bg: 'Cambiar color de fondo',
    bg_color: 'Color de fondo',
    font_size: 'Tamaño de letra',
    normal: 'Normal',
    change_color: 'Cambiar color del texto',
    slant_text: 'Texto inclinado',
    text_radius: 'Radio del texto',
    vertical_align: 'Alineación vertical',
    horizontal_align: 'Alineación horizontal',
    change_icon_color: 'Cambiar color del ícono',
    upload_icon: 'Subir ícono',
    upload_signature: 'Subir firma',
    add_another_sign: 'Agregar otra firma',
    name_badges: 'Nombre de insignias',
    should_less_150: 'debe tener 150 caracteres o menos',
    your_badge: 'Tu insignia',
    do_you_want_delete_badge: '¿Quieres eliminar esta insignia?',
    do_you_want_delete_cert: '¿Quieres eliminar este certificado?',
    upload_logo: 'Subir logotipo',
    name_of_cert: 'Nombre del certificado',
    upload_cert: 'Actualizar certificado',
    your_cert: 'Tu certificado',
    translate_to: 'Traducir a',
    select_file_attach: 'Seleccionar archivo para adjuntar',
    certificate: 'Certificado',
    badge: 'Insignia',
    publish_options: 'Opciones de publicación',
    publish_skills_journey: 'Publicar ruta de habilidades',
    videos: 'Videos',
    generate_ai_video:
      'El proceso de generación del video puede tardar. Te notificaremos por email cuando esté listo.',
    trainer_information: 'Información del instructor',
    promotional_video_link: 'Enlace del video promocional',
    please_select: 'Por favor selecciona',
    image_name: 'Nombre de imagen:',
    image_size: 'Tamaño de imagen:',
    charecters_fifteen_less: '15 caracteres o menos',
    leadership: 'Liderazgo',
    text_arc: 'Arco de texto',
    vertical: 'Vertical',
    horizontal: 'Horizontal',
    badge_history: 'Historial de insignias',
    templates: 'Plantillas',
    sign: 'Firma',
    logo: 'Logotipo',
    certificate_history: 'Historial de certificados',
    please_wait: 'Por favor espera...',
    information: 'Información',
    support_five_thousand_live_event:
      'Soporta hasta 5000 participantes en el evento en vivo',
    support_ten_live_event: 'Soporta hasta 10 participantes en video en vivo',
    we_will_back_participant:
      'Volveremos con eventos que permiten más participantes.',
    course_objectives: 'Objetivos del curso',
    course_outlines: 'Temario del curso',
    price_dollor: 'precio (USD)',
    not_completed: 'No completado',
    enable_marketplace: 'Habilitar Marketplace',
    enable_course_ai: 'Habilitar creación de cursos con IA',
    enable_report_to_admin: 'Habilitar reportes para el administrador',
    enable_white_label: 'Habilitar Marca Blanca',
    enable_eleven_labs_for_maze_play: 'Habilitar Elevenlabs para Maze Play',
    enable_eleven_labs_for_maze_play_cloned:
      'Habilitar voz clonada de Elevenlabs',
    simulation_quiz: 'Cuestionario de simulación',
    bg_color_setting: 'Configuración de color de fondo',
    color_preview: 'Vista previa del color',
    choose_new_color: 'Elegir nuevo color',
    remove_color: 'Quitar color',
    apply_color: 'Aplicar color',
    elemeent_in_a_sceenario_page:
      'No puedes agregar otro elemento en una página de escenario. Usa otra página o elimina el escenario primero.',
    no_data_found: 'No se encontraron datos.',
    references: 'Referencias',
    open_file: 'Abrir archivo',
    showing_result: 'Mostrando resultados:',
    fiften_day_free_trail: 'Prueba gratis por 15 días',
    your_browser_does_not_support:
      'Tu navegador no soporta el elemento de audio.',
    podcast_desc: 'Descripción del pódcast',
    input_podcast_desc: 'Por favor ingresa la descripción del pódcast',
    podcast_obj: 'Objetivos del pódcast',
    input_podcast_obj: 'Por favor ingresa los objetivos del pódcast',
    podcast_outline: 'Esquema del pódcast',
    input_podcast_outline: 'Por favor ingresa el esquema del pódcast',
    add_file: 'Agregar archivo',
    generate_podcast_audio: 'Generar audio del pódcast',
    generate_uploaded_file_input_parameter:
      'Genera el contenido relacionado con los archivos subidos por el usuario usando los parámetros indicados.',
    go_backe_generation_state: 'Regresar al estado de generación de contenido.',
    create_ai_powered_podcast:
      'Crea un episodio de pódcast con audio generado por IA.',
    generate_voice_for_all_podcast:
      'Por favor genera la voz para todos los episodios del pódcast',
    create_podcast_episode: 'Crear episodio del pódcast',
    voice_name: 'Nombre de la voz',
    input_custom_name: '¡Por favor ingresa un nombre personalizado!',
    enter_custom_name: 'Ingresa el nombre de voz personalizado',
    upload_complete: 'Carga completada',
    uploading_in_progress: 'Subiendo...',
    podcast_stream_content: 'Contenido en vivo del pódcast',
    upload_podcast_cover: '¡Por favor sube la portada del pódcast!',
    enter_podcast_name: '¡Por favor ingresa el nombre del pódcast!',
    podcast_topic: 'Tema del pódcast',
    enter_podcast_topic: '¡Por favor ingresa el tema del pódcast!',
    enter_podcast_desc: '¡Por favor ingresa la descripción del pódcast!',
    number_of_speaker: 'Número de oradores',
    select_the_number_of_speaker:
      '¡Por favor selecciona el número de oradores!',
    number_of_episode: 'Número de episodios',
    input_number_of_episode: '¡Por favor ingresa el número de episodios!',
    podcast_length: 'Duración del pódcast',
    select_the_podcast_length: '¡Por favor selecciona la duración del pódcast!',
    short_podcast: 'Corto (5–10 min)',
    medium_podcast: 'Medio (15–18 min)',
    long_podcast: 'Largo (18+ min)',
    name_of_host: 'Nombre del anfitrión',
    enter_host_name: '¡Por favor ingresa el nombre del anfitrión!',
    guest_name: 'Nombre de los invitados',
    enter_guest_name: '¡Por favor ingresa el nombre del invitado!',
    choose_speaker_tone: 'Selecciona el tono del orador',
    enter_speaker_tone: '¡Por favor selecciona el tono del pódcast!',
    informal: 'Informal',
    formal: 'Formal',
    serious: 'Serio',
    light_humor: 'Humor ligero',
    casual: 'Casual',
    select_content_source: 'Seleccionar fuente de contenido',
    from_internet: 'Desde Internet',
    upload_pdf_internet: 'Subir un PDF o documento interno',
    note: 'Nota:',
    podcast_content_will_be_automatically_generated:
      'El contenido del pódcast será generado automáticamente usando fuentes confiables de Internet.',
    upload_or_select_file: '¡Por favor sube o selecciona archivo(s)!',
    podcast_eposode_title: 'Título del episodio del pódcast',
    enter_podcast_title: '¡Por favor ingresa el título del episodio!',
    podcast_episode_des: 'Descripción del episodio del pódcast',
    enter_podcast_episode_des:
      '¡Por favor ingresa la descripción del episodio!',
    voice: 'Voz',
    music: 'Música',
    select_music: 'Seleccionar música',
    play_the_music: 'Reproducir música',
    stop_the_music: 'Detener música',
    context: 'Contexto',
    generate_audio_content_selected_voice:
      'Esto generará el audio del contenido según las voces seleccionadas.',
    required_field_before_submitting:
      'Por favor completa todos los campos requeridos antes de enviar.',
    regenerate_voice: 'Regenerar voz',
    generate_voice: 'Generar voz',
    your_browser_does_not_suppot:
      'Tu navegador no admite el elemento de audio.',
    are_sure_leave_podcast: '¿Estás seguro de salir del pódcast?',
    broadcast_ongoing:
      'La transmisión está en curso. ¿Realmente deseas salir de esta página?',
    brodcaster_unavailable: 'El transmisor no está disponible en este momento.',
    setting_calender_for_booking: 'Configurando calendario para reservas',
    add_calender: 'Agregar calendario',
    waiting_join_host: 'Esperando a que se una el anfitrión...',
    no_reviews_found: 'No se encontraron reseñas.',
    rated_already: 'Ya calificaste este evento en vivo.',
    downlink_png: 'descargar_png',
    downlink_jpg: 'descargar_jpg',
    donwload_file_format:
      'Selecciona el formato de archivo que deseas descargar.',
    crashed_event:
      'Este evento falló. Necesitas crear uno nuevo. Disculpa las molestias.',
    prompt: 'Prompt:',
    generated_image: '🚀 Generando tu imagen... Por favor espera.',
    download_add: 'Descargar todo',
    setting_generator: 'Configuración del generador',
    enter_image_prompt: 'Ingresa un prompt de imagen',
    image_prompt: 'Ingresa tu prompt de imagen',
    negative_prompt: 'Prompt negativo',
    negative_image_prompt: 'Ingresa tu prompt negativo de imagen',
    number_output: 'Número de resultados',
    enter_number_output: 'Ingresa el número de resultados',
    image_style: 'Selecciona el estilo de imagen',
    output_format: 'Formato de salida',
    seeds: 'Semillas',
    enter_seeds: 'Ingresa el número de semillas',
    performance_mode: 'Modo de rendimiento',
    quality: 'Calidad',
    speed: 'Velocidad',
    balanced: 'Balanceado',
    guidance_scale: 'Escala de guía',
    enter_guidance: 'Ingresa la escala de guía',
    select_image: 'Selecciona imagen.',
    image_prmt: 'Prompt de imagen',
    generate_image_list_empty: 'La lista de imágenes generadas está vacía.',
    knowledge_center_tooltrip_des:
      'Obtén respuestas concisas y precisas a una amplia gama de preguntas, incluidas las de cultura general. Las respuestas se generan a partir de información general en Internet utilizando un modelo de IA entrenado con textos diversos.',
    contexts: 'Contextos',
    ai_processing_video_sharebot:
      'El procesamiento del video por IA tardará alrededor de 24 horas en completarse y reflejarse en Sharebot.',
    remove_sharebot_video:
      'Si deseas eliminar la referencia del video a Sharebot, por favor elimina también la transcripción correspondiente junto con el video.',
    remove_sharebot_video_audio:
      'Eliminar la transcripción eliminará la referencia de video/audio en Sharebot, pero el video seguirá apareciendo en la biblioteca/canal de medios.',
    monthly_live_stream:
      'Para cambiar tu límite mensual de transmisiones en vivo, por favor contacta a',
    monthly_transcribe_limit:
      'Para cambiar tu límite mensual de transcripción, por favor contacta a',
    must_be_one_to_three_hundred: 'Debe estar entre 1 y 300 minutos.',
    all_field_required: 'Todos los campos son obligatorios.',
    duration_minute: 'Duración (máximo 300 minutos)',
    gender: 'Género',
    select_gender: 'Selecciona el género',
    accent: 'Acento',
    select_accent: 'Selecciona el acento',
    create_voice: 'Crear voz',
    enter_voice_name: 'Ingresa el nombre de la voz',
    select_voice_gender: 'Por favor, selecciona el género de la voz',
    upload_voice: 'Sube tu voz',
    upload_voice_mp_three: 'Sube tu voz (.mp3)',
    cloned_voice: 'Voces clonadas',
    voice_type: 'Tipo de voz',
    select_voice_type: 'Selecciona el tipo de voz',
    sharelook_stand: 'Estándar',
    sharelook_premium: 'Premium',
    sharelook_custum_voice: 'Personalizada (Clonación de voz)',
    create_auto_flow: 'Crear flujo automático',
    how_many_layers: '¿Cuántas capas?',
    verify_selection: 'Verificar selección',
    uploaded_successful: 'Subida exitosa',
    upload_failed: 'Error al subir',
    upload_only_five_mb: 'Subir contenido (archivos PDF, máx. 5)',
    docs_from_org_library: 'Usar documento de la biblioteca de la organización',
    failed_maze_generate:
      'No se pudo generar el laberinto. Por favor, inténtalo nuevamente.',
    generate_metamaze: 'Generando MetaMaze...',
    metamaze_being_generated:
      'Tu MetaMaze está siendo generado. Serás notificado por correo electrónico cuando el proceso haya terminado.',
    metamaze_generate_successfully: '¡MetaMaze generado con éxito!',
    metamaze_with_proceed: 'Ahora puedes continuar con el MetaMaze.',
    ai_metamaze_generate: 'Generación de MetaMaze con IA',
    what_kind_maze_create: '¿Qué tipo de laberinto quieres crear?',
    manual_metamaze_creation: 'Creación manual de MetaMaze',
    manually_maze_customizing_scnario:
      'Crea un laberinto manualmente personalizando el escenario y el árbol de opciones',
    maze_ai_generated: 'Generar laberinto automáticamente con IA',
    unmark_deadend: 'Desmarcar como callejón sin salida',
    mark_deadend: 'Marcar como callejón sin salida',
    select_multiple_image_for_scenario:
      'Puedes seleccionar varias imágenes para el escenario.',
    select_your_image: 'Tus imágenes seleccionadas',
    click_to_preview: 'Haz clic para previsualizar',
    are_you_sure_delete_image: '¿Estás seguro de eliminar esta imagen?',
    select_image_from_library:
      'Selecciona imagen desde la biblioteca multimedia',
    uploading_video: 'Subiendo video...',
    tree_node_type: 'Tipo de nodo del árbol',
    correct_option_scenario: 'Opción o escenario correcto',
    incorrect_option: 'Opción incorrecta',
    option_scenario_without_text: 'Opción o escenario sin texto',
    dead_end: 'Callejón sin salida (borde rojo)',
    correct_path: 'Camino correcto',
    incorrect_path_not_selected_correct_option_path:
      'Camino incorrecto / Camino donde no se seleccionó la opción correcta.',
    double_click_on_tree_node:
      'Al hacer doble clic en un nodo del árbol, el editor de texto se desplazará automáticamente para mostrar el contenido de ese nodo.',
    add_scenario: 'Agregar escenario',
    add_option: 'Agregar opción',
    an_error_occured: 'Ocurrió un error:',
    download_summary: 'Descargar resumen',
    step_wise_analysis: 'Análisis paso a paso',
    step: 'Paso',
    upload_csv_file: 'Subir archivo CSV',
    download_template_to_import: 'Descargar plantilla de ejemplo para importar',
    please_input_email: 'Por favor, ingresa el correo electrónico.',
    email_at_least_three_characters:
      'El correo debe tener al menos 3 caracteres.',
    email_cannot_be_empty: 'El correo no puede estar vacío.',
    input_email_in_new_line: 'Por favor, ingresa los correos (uno por línea)',
    role: 'Rol',
    select_role: 'Por favor, selecciona un rol',
    select_group: 'Por favor, selecciona un grupo',
    identification_number: 'Número de identificación (opcional)',
    add_identification_number: 'Por favor, agrega un número de identificación',
    pie_chart_of_all_categories:
      'Gráfico circular de todas las categorías según su uso en Sharelook.',
    total_sharesphere_question_answered_by_users:
      'Total de preguntas de ShareSphere respondidas por los usuarios en la organización actual, con sus categorías respectivas y los resultados de éxito o fallo.',
    voice_style_over_the_text:
      'Aquí puedes usar varios estilos de voz sobre el texto que escribas. Bla bla bla. Lorem Ipsum es simplemente texto de relleno de la industria de la impresión y la tipografía. Ha sido el texto estándar desde el siglo XVI.',
    input_your_question: '¡Por favor, ingresa tu pregunta!',
    make_me_sales_manager:
      'Ej: ¿Qué puede hacer que me convierta en gerente de ventas?',
    enter_the_number_relevant_document:
      'Ingresa el número de documentos relevantes',
    please_wait_loading_result: 'Por favor espera, cargando resultados...',
    no_result_found:
      'No se encontraron resultados. Intenta hacer otra pregunta.',
    browser_doesnot_support_iframes: 'Tu navegador no soporta iframes',
    total_duration: 'Duración total',
    number_of_messages: 'Número de mensajes',
    search_result: 'Resultados de búsqueda',
    count_result: '(1244 resultados)',
    your_other_interests: 'Tus otros intereses',
    your_total_score: 'Tu puntuación total',
    add_a_question: '+agregar una pregunta',
    travia_question_empty: 'La lista de preguntas de Travia está vacía.',
    video_generation_is_on_queue: '¡Tu video está en cola para generarse!',
    checking_video_status: 'Verificando el estado del video...',
    total_quizzes: 'Cuestionarios totales',
    number_of_votes: 'Número de votos',
    total_events: 'Eventos totales',
    number_of_rates: 'Número de calificaciones',
    number_of_likes: 'Número de "me gusta"',
    all_courses: 'Todos los cursos',
    total_questions: 'Total de preguntas',
    no_skill_journey: '¡No hay trayectorias de habilidades disponibles!',
    search_no_results: '- ¡sin resultados disponibles!',
    no_image_generated: '¡No se generaron imágenes!',
    all_topic_in_this_lesson:
      'Todos los temas de esta lección serán eliminados. Esta acción no se puede deshacer.',
    content_has_been_generated: 'Se ha generado contenido para este tema.',
    update_course_template: 'Actualizar plantilla del curso',
    add_course_template: 'Agregar plantilla del curso',
    create_course_now: 'Crear curso ahora',
    preview_course: 'Previsualizar curso',
    layout: 'Diseño',
    import_from_youtube: 'Importar desde YouTube',
    my_media_library: 'Mi biblioteca multimedia',
    bg_added: 'Fondo agregado',
    add_bg: 'Agregar fondo',
    booked_schedule: 'Horario reservado',
    add_schedule: 'Agregar horario',
    are_you_delete_schedule:
      '¿Estás seguro de que deseas eliminar este horario?',
    add_task: 'Agregar tarea',
    update_calender: 'Actualizar calendario',
    manage_cookies: 'Administrar cookies',
    cookie_banner_text:
      'Usamos cookies para mejorar tu experiencia de navegación, analizar el tráfico del sitio web y personalizar el contenido. Tu privacidad es importante para nosotros.',
    accept_all_cookies: 'Aceptar todas las cookies',
    reject_all: 'Rechazar todas',
    customize: 'Personalizar',
    cookie_preferences_title:
      'Preferencias de cookies y configuración de privacidad',
    privacy_subtitle:
      'Tu privacidad es importante para nosotros. Elige qué cookies aceptas. Puedes cambiar esta configuración en cualquier momento.',
    save_choices: 'Guardar mis elecciones',
    strictly_necessary: 'Estríctamente necesarias',
    strictly_necessary_desc:
      'Estas cookies son esenciales para que el sitio web funcione correctamente. Permiten funciones básicas como navegación por páginas, envío de formularios y acceso a áreas seguras. El sitio no puede funcionar correctamente sin ellas.',
    analytics_performance: 'Analítica y rendimiento',
    analytics_performance_desc:
      'Estas cookies nos ayudan a entender cómo los visitantes interactúan con nuestro sitio web mediante la recopilación y el informe de información de manera anónima. Esto ayuda a mejorar el rendimiento del sitio y la experiencia del usuario.',
    advertising_marketing: 'Publicidad y marketing',
    advertising_marketing_desc:
      'Estas cookies se usan para que los mensajes publicitarios sean más relevantes para ti. Evitan que el mismo anuncio aparezca repetidamente y garantizan que los anuncios se muestren correctamente para los anunciantes.',
    tracking_social: 'Seguimiento y redes sociales',
    tracking_social_desc:
      'Estas cookies permiten funcionalidades avanzadas y personalización, como funciones de redes sociales y contenido personalizado. Pueden ser configuradas por nosotros o por proveedores externos.',
    functional: 'Funcionales',
    functional_desc:
      'Estas cookies permiten funcionalidades avanzadas como soporte de chat, ayuda en vivo y otras funciones interactivas que mejoran tu experiencia en el sitio web.',
    your_rights: 'Tus derechos:',
    rights_description:
      'Puedes retirar tu consentimiento en cualquier momento, acceder a tus datos o solicitar su eliminación en cualquier momento.',
    withdraw_consent: 'Retirar todo el consentimiento',

    how_many_options: 'Cuántas opciones',
    add_content: 'Agregar contenido',
    downloads_center: 'Centro de descargas',
    sharelook_help_center: 'Centro de ayuda de Sharelook',
    channel_outline: 'Esquema del canal',
    channel_objectives: 'Objetivos del canal',
    no_sop_available: 'No hay lista de SOP disponible.',
    generate_world_summary: 'Generar escenario',
    world_scenario: 'Escenario del mundo real',
    drag_icon_hint:
      'Consejo: Arrastra el ícono sobre el lienzo para posicionarlo',
    drag_text_hint:
      'Consejo: Arrastra el texto sobre el lienzo para posicionarlo',
    edit_badge: 'Editar insignia',
    create_new_badge: 'Nueva insignia',
    select_video_preview: 'Selecciona un video para previsualizar',
    certificate_title_required: 'El título del certificado es obligatorio',
    discard_changes: 'Descartar cambios',
    edit_certificate: 'Editar certificado',
    add_another_logo: 'Agregar otro logotipo',
    optional: 'Opcional',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: 'Crear una nueva misión',
    quest_filter_title: 'Misión',
    sharelook_assistance: 'Asistencia Sharelook',
    upload_scorm_zip: 'Subir archivo Scorm Zip',
    only_letters_numbers_space_dot_allowed:
      '¡Solo se permiten letras, números, espacios y puntos!',
    video_playing: 'Reproduciendo',
    course_price_message:
      '*El curso solo se publicará para usuarios dentro de la organización y no puede revenderse en el mercado.',
    lesson_must_be_positive: 'El número de lecciones debe ser mayor que 1',
    btn_proceed: 'Continuar',
    rule_select_music: 'Por favor selecciona música',
    course_info: 'Información del curso',
    content_selection: 'Selección de contenido',
    course_content_source: 'Fuente de contenido del curso',
    choose_how_to_source: 'Elige cómo obtener contenido para este curso:',
    automatic_selection: 'Selección automática',
    system_will_automatically_select_relavant_documents:
      'El sistema seleccionará automáticamente los documentos relevantes de tu biblioteca',
    manual_selection: 'Selección manual',
    choose_specific_documents_from_your_library:
      'Elige documentos específicos de tu biblioteca',
    upload_files: 'Subir archivos',
    upload_new_documents:
      'Sube nuevos documentos (PDF, DOC, DOCX, PPT, PPTX, TXT) - Máximo 5 archivos',
    file: 'archivo',
    ready_to_upload: 'listo para subir',
    clear_all: 'Borrar todo',
    confirm_course_wide_premiew: 'Confirmar vista previa de todo el curso',
    generate_course_preview: 'Generar vista previa del curso',
    instructions_across_the_course_to_generate:
      'Aplicaremos tus instrucciones en todo el curso para generar una vista previa. Revisa todo primero y luego decide si deseas mantener o descartar los cambios.',
    instruction_to_preview_course_wide:
      'Instrucciones para vista previa de todo el curso:',
    edit_content: 'Editar contenido',
    manage_course_template: 'Administrar plantilla del curso',
    undo: 'Deshacer',
    apply_changes: 'Aplicar cambios',
    characters: 'caracteres',
    apply_all: 'Aplicar todo',
    apply_to_all: 'Aplicar a todo',
    use_this_content: 'Usar este contenido',
    original: 'Original',
    edited: 'Editado',
    edited_content_preview: 'Vista previa del contenido editado',
    apply_edits_to_all_topices: '¿Aplicar ediciones a todos los temas?',
    current_editing_instructions_across_the_whole_course:
      'Esto aplicará tus instrucciones actuales a todo el curso. Puedes revisar la vista previa combinada antes de guardar.',
    edit_content_instructions: 'Instrucciones para editar contenido',
    generate_content_for_this_topic_instruction:
      'Generar contenido para este tema usando tus instrucciones',
    descrip_edit_content:
      'Describe cómo editar este contenido (por ejemplo, resumir, simplificar, reformular)',
    try_short_clear_direcctives:
      'Prueba directivas cortas y claras. Ejemplos: “reducir a 100 palabras, mantener puntos clave”, “simplificar lenguaje”, “hacer más conciso y eliminar relleno”.',
    we_preserve_the_core_meaning:
      'Preservamos el significado principal al aplicar tus instrucciones.',
    feedback_optional: 'Comentarios (Opcional)',
    write_your_feedback_here: 'Escribe tus comentarios aquí',
    from_web: 'Desde web',
    from_desktop: 'Desde escritorio',
    pleae_wait_processing: 'Por favor, espera mientras se procesa...',
    create_simulation_from_screen_capture:
      'Crear simulación desde captura de pantalla',
    sharelook_not_found: 'ShareLook no encontrado',
    sharelook_screen_capture_application_not_be_opened:
      'No se pudo abrir la aplicación ShareLook Screen Capture. Puede que no esté instalada en tu computadora.',
    download_sharelook: 'Descargar ShareLook',
    launch_sharelook_application: 'Abrir aplicación ShareLook',
    this_will_open_the_sharelook_application_for_screen_capture:
      'Esto abrirá la aplicación ShareLook para captura de pantalla.',
    sharelook_dosenot_open:
      'Si ShareLook no se abre, puede que no esté instalada en tu computadora.',
    open_sharelook: 'Abrir ShareLook',
    download_app: 'Descargar aplicación',
    background_image_setting: 'Configuración de imagen de fondo',
    current_image: 'Imagen actual',
    change_image: 'Cambiar imagen',
    remove_image: 'Eliminar imagen',
    no_background_image_selected:
      'No se ha seleccionado ninguna imagen de fondo',
    add_image: 'Agregar imagen',
    this_will_open_for_screen_recording:
      'Esto abrirá la aplicación ShareLook para grabación de pantalla.',
    ai_image_generation: 'Generación de imagen AI',
    image_edit: 'Editar imagen',
    text_to_image: 'Texto a imagen',
    output_gallary: 'Galería de resultados',
    instant_generation: 'Listo para generación instantánea',
    prompt_and_unleash_the_power: 'Ingresa tu prompt y libera el poder',
    use_this_image: 'Usar esta imagen',
    error_generating: 'Error al generar.',
    generation_tips: 'Consejos de generación',
    detailed_descriptions_for_more_accurate_results:
      'Usa descripciones detalladas para obtener resultados más precisos',
    reference_image: 'Imagen de referencia',
    select_pixel_image: 'Seleccionar imagen de píxeles',
    max_mb: 'Máx. 50 MB',
    please_enter_text_to_appear_image:
      'Ingresa el texto que aparecerá en la imagen',
    enter_text_to_apear_in_the_image:
      'Ingresa el texto que aparecerá en la imagen',
    generate_image: 'Generar imagen',
    prompt_assistant: 'Asistente de prompts',
    generate_image_using_suggested_prompt:
      'Generar imagen usando prompt sugerido',
    talk_to_ai_about_the_image_generate:
      'Habla con AI sobre la imagen que deseas generar',
    ask_for_prompt_suggestions: 'Pide sugerencias de prompt...',
    enter_a_search_term_to_find_stock_images:
      'Ingresa un término de búsqueda para encontrar imágenes de stock',
    choose_your_content_source: 'Elige tu fuente de contenido:',
    upload_new_document_from_your_device:
      'Subir nuevos documentos desde tu dispositivo',
    automatic_library_selection: 'Selección automática de biblioteca',
    system_automatically_selects_relevant_document:
      'El sistema selecciona automáticamente documentos relevantes',
    manual_library_selection: 'Selección manual de biblioteca',
    generate_content: 'Generar contenido',
    add_to_current_page: 'Agregar a la página actual',
    generate_bullet_points: 'Generar puntos clave',
    generating: 'Generando',
    this_may_take_a_few_moments: 'Esto puede tardar unos momentos',
    apply_to_page: 'Aplicar en la página',
    scenario_escription: 'Descripción del escenario:',
    feedback: 'Comentarios',
    form_mode: 'Modo de formulario',
    chat_mode: 'Modo de chat',
    this_will_generate_a_continuation_of_the_seleccted_story:
      'Esto generará una continuación de la historia seleccionada usando IA.',
    continue_this_story_question: '¿Continuar esta historia?',
    continue_this_story: 'Continuar esta historia',
    what_will_happen: 'Qué pasará:',
    the_ai_will_analyze_the_existing_story_content:
      'La IA analizará el contenido existente de la historia',
    generate_a_natural_continuation_that_follows_the_same_tone:
      'Genera una continuación natural que siga el mismo tono y estilo',
    create_new_content_that_build_upon_the_current_narrative:
      'Crea contenido nuevo que se base en la narrativa actual',
    this_process_may_take_a_few_moments_to_complete:
      'Este proceso puede tardar unos momentos en completarse.',
    no_existing_stories_found_for_this_course:
      'No se encontraron historias existentes para este curso.',
    create_your_first_story: 'Crea tu primera historia',
    existing_stories: 'Historias existentes',
    create_new_story: 'Crear nueva historia',
    tone: 'Tono',
    style: 'Estilo',
    genre: 'Género',
    loading_your_stories: 'Cargando tus historias...',
    edit_story: 'Editar historia',
    story_preferences: 'Preferencias de la historia',
    please_input_your: 'Por favor ingresa tu',
    add_character_names_and_press_enter:
      'Agrega nombres de personajes y presiona Enter',
    select_or_type_your: 'Selecciona o escribe tu',
    enter_your: 'Ingresa tu',
    position_of_the_story_in_the_lesson:
      'Posición de la historia en la lección. La historia se añadirá como un bloque en la posición indicada.',
    save_previous_content_on_the_pages:
      'Guardar contenido previo en las páginas',
    the_existing_content_in_the_selected_pages:
      'El contenido existente en las páginas seleccionadas será reemplazado por la historia generada.',
    real_world_scenario: 'Escenario del mundo real',
    add_optional_instructions:
      'Agrega instrucciones opcionales (tono, longitud, audiencia, etc.)',
    ready_to_enerate_your_real_world_scenario:
      'Listo para generar tu escenario del mundo real',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      'Haz clic en "Generar escenario del mundo real" para crear un escenario realista basado en el contenido de tu lección.',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'La IA analizará el tema y contenido de tu lección',
    generate_a_practical_real_world_scenario:
      'Genera un escenario práctico del mundo real',
    you_can_then_edit_and_customize_the_result:
      'Luego podrás editar y personalizar el resultado',

    add_it_as_a_new_page_to_your_lesson:
      'Agregar como nueva página a tu lección',
    regenerate_with_instructions: 'Regenerar con instrucciones',
    add_real_world_scenario: 'Agregar escenario del mundo real',
    generate_real_world_scenario: 'Generar escenario del mundo real',
    simulation_has_been_stopped: '¡La simulación ha sido detenida!',
    loading_simulation: 'Cargando simulación...',
    you_have_exhausted_all_the_attempts: 'Has agotado todos los intentos',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      'Estudia el escenario en esta página y selecciona la respuesta correcta de las opciones a continuación.',
    attempts_limit_reached:
      'Se alcanzó el límite de intentos. Puedes jugar nuevamente, pero tu puntaje no se guardará.',
    play_again: 'Jugar nuevamente',
    import_music_from_computer: 'Importar música desde la computadora.',
    more: 'más',
    no_badge_yet: 'Aún no hay insignias',
    competition_filter: 'Filtro de competencia',
    global_leaderboard: 'Tabla de clasificación global',
    placeholder_for_the_global_leaderboard:
      'Este es un marcador de posición para la Tabla de Clasificación Global.',
    badge_editor: 'Editor de insignias',
    adjust_the_appearance_of_this_badge_icon:
      'Ajusta la apariencia de este ícono de insignia. Los cambios se aplican solo a esta insignia.',
    badge_style: 'Estilo de insignia',
    the_image_must_be_pixels: 'La imagen debe ser de 200x200 píxeles.',
    badge_name: 'Nombre de la insignia',
    badge_descrription: 'Descripción de la insignia',
    enter_badge_criteria: 'Ingresa los criterios de la insignia',
    discard: 'Descartar',
    badge_enable: 'Insignias habilitadas',
    award_users_with_badges_to_highlight_the_milestones:
      'Otorga insignias a los usuarios para resaltar los hitos en su aprendizaje.',
    badge_types: 'Tipos de insignias',
    enable_or_disable_specific_badge_types_for_your_users:
      'Habilita o deshabilita tipos específicos de insignias para tus usuarios.',
    levels_enabled: 'Niveles habilitados',
    level_rules: 'Reglas del nivel',
    points: 'Puntos',
    add_new_level: 'Agregar nuevo nivel',
    add_level: 'Agregar nivel',
    points_enabled: 'Puntos habilitados',
    learning_activities_and_encourage_healthy_competition:
      'Otorga puntos a los usuarios por diferentes actividades de aprendizaje y fomenta la competencia saludable.',
    award_points: 'Otorgar puntos',
    the_following_equates_the_value_of_one_item_completion:
      'Lo siguiente equivale al valor de completar un ítem',
    general: 'General',
    others: 'Otros',
    certificate: 'Certificado',
    quiz_passed: 'Cuestionario aprobado',
    tip_approved: 'Consejo aprobado',
    tip_liked: 'Consejo gustado',
    rewards: 'Recompensas',
    offer_discounts_when_learners_achieve:
      'Ofrece descuentos cuando los alumnos alcanzan un conjunto de puntos, insignias o niveles.',
    give_rewards: 'Dar recompensas',
    discount_course_purchases_by: 'Descuento en la compra de cursos de',
    with_points_more_than: 'con puntos mayores a',
    with_badges_more_than: 'con insignias mayores a',
    with_level_upwards_more_than: 'con nivel superior a',
    leaderboard: 'Tabla de clasificación',
    leaderboard_enabled: 'Tabla de clasificación habilitada',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      'Las tablas de clasificación ofrecen a los usuarios una visión general de su progreso en puntos en comparación con otros.',
    show_levels: 'Mostrar niveles',
    show_points: 'Mostrar puntos',
    show_badges: 'Mostrar insignias',
    show_courses: 'Mostrar cursos',
    show_certificates: 'Mostrar certificados',
    leaderboard_settings: 'Configuración de la tabla de clasificación',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      'Configura experiencias atractivas en la tabla de clasificación para aumentar la motivación de los estudiantes.',
    award_users_with_points_for_different_learning_activities:
      'Otorga puntos a los usuarios por diferentes actividades de aprendizaje.',
    badge_set: 'Conjunto de insignias',
    choose_the_type_of_badges_your_users:
      'Elige el tipo de insignias que tus usuarios obtendrán mientras aprenden.',
    levels: 'Niveles',
    Levels_represent_the_stages:
      'Los niveles representan las etapas en el camino de aprendizaje de un usuario.',
    enabled: 'Habilitado',
    disabled: 'Deshabilitado',
    quick_select: 'Selección rápida',
    yesterday: 'Ayer',
    last_week: 'La semana pasada',
    Last_month: 'El mes pasado',
    last_quarter: 'El trimestre pasado',
    historical_leaderboard: 'Tabla histórica',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      'Monitorea tu desempeño y ve cómo te ubicas entre tus compañeros',
    time_period: 'Periodo de tiempo',
    page_of: 'Página 1 de 1',
    edit_competition: 'Editar competencia',
    create_competition: 'Crear competencia',
    arrow_right: 'flecha-derecha',
    update_competition: 'Actualizar competencia',
    competition_title: 'Título de la competencia',
    enter_competition_title: 'Ingresa el título de la competencia',
    enter_competition_description: 'Ingresa la descripción de la competencia',
    leaderboard_skill: 'Habilidad',
    select_a_skill: 'Selecciona una habilidad',
    no_skills_found: 'No se encontraron habilidades',
    competition_period: 'Periodo de la competencia',
    add_badge_rule: 'Agregar regla de insignia',
    create_badge: 'Crear insignia',
    add_level_rule: 'Agregar regla de nivel',
    selected_participants: 'Participantes seleccionados',
    no_participants: 'No hay participantes',
    start_end_date: 'Fecha inicio–fin',
    created_date: 'Creado por',
    new_competition: 'Nueva competencia',
    competitions_list: 'Lista de competencias',
    search_competitions: 'Buscar competencias...',
    are_you_sure_you_want_to_delete_the_competition:
      '¿Estás seguro de que deseas eliminar la competencia?',
    history: 'Historial',
    export: 'Exportar',
    search_by_name: 'Buscar por nombre...',
    no_historical_data_available_for_the_selected_period:
      'No hay datos históricos disponibles para el periodo seleccionado.',
    no_leaderboard_data_available:
      'No hay datos disponibles para la tabla de clasificación.',
    competitions: 'Competencias',
    leaderboards: 'Tablas de clasificación',
    welcome_back: 'Bienvenido de nuevo',
    track_your_performance_and_see: 'Monitorea tu desempeño y ve tu posición',
    team_leaderboard: 'Tabla de clasificación del equipo',
    try_again: 'Intentar nuevamente',
    no_competitions_for_search: 'No hay competencias disponibles para',
    no_competitions_available: 'No hay competencias disponibles',
    no_competitions_matching_search:
      'No se encontraron competencias que coincidan con tu búsqueda. Intenta ajustar tus términos o vuelve más tarde.',
    no_competitions_general:
      'Actualmente no hay competencias configuradas. Vuelve más tarde o contacta a tu administrador para crear nuevas competencias.',
    media_management: 'Gestión de medios',
    badgess_set: 'Conjunto de insignias',
    choose_the_default_visual_style_for_badge:
      'Elige el estilo visual predeterminado de los iconos de insignia utilizados en la plataforma.',
    enable_badges: 'Activar insignias',
    add_badge: 'Agregar insignia',
    min: 'Mín',
    max: 'Máx',
    your_rank: 'Tu rango',
    your_points: 'Tus puntos',
    your_level: 'Tu nivel',
    rank: 'Rango #',
    level: 'Nivel',
    progress: 'Progreso',
    new_folder: 'Nueva carpeta',
    file_upload: 'Subir archivo',
    writer: 'Autor',
    text_documents: 'Documentos de texto',
    spreadsheets: 'Hojas de cálculo',
    impress: 'Presentación',
    presentations: 'Presentaciones',
    capture_desktop_screen: 'Capturar pantalla del escritorio',
    capture_desktop_screens: 'Capturar pantallas del escritorio',
    your_documents: 'Tus documentos',
    manage_your_videos_images_audio_files:
      'Gestiona tus videos, imágenes, archivos de audio y otros recursos usados en la creación de contenido.',
    your_organization_documents: 'Documentos de tu organización',
    keep_your_organization_creative_assets_organized:
      'Mantén los recursos creativos de tu organización organizados y accesibles—optimiza el trabajo en equipo y la producción de contenido.',
    your_public_documents: 'Tus documentos públicos',
    curated_collection_of_media_assets_available:
      'Colección curada de recursos multimedia disponibles para todos—explora, reutiliza y crea.',
    your_download_center_documents: 'Documentos de tu centro de descargas',
    repository_of_approved_media_assets_for_download:
      'Repositorio de recursos multimedia aprobados para descargar y usar en tus proyectos.',
    search_files_and_folders: 'Buscar archivos y carpetas..',
    home: 'Inicio',
    folders: 'Carpetas',
    folder_name: 'Nombre de la carpeta',
    owner: 'Propietario',
    last_updated: 'Última actualización',
    action: 'Acción',
    no_folders_found: 'No se encontraron carpetas',
    files: 'Archivos',
    enabling_ai: 'Activando IA...',
    rename: 'Renombrar',
    copy: 'Copiar',
    move: 'Mover',
    verson_history: 'Historial de versiones',
    manage_permission: 'Gestionar permisos',
    generate_audit_report: 'Generar informe de auditoría',
    last_edited: 'Última edición',
    no_files_found: 'No se encontraron archivos',
    are_you_sure_you_want_to_make_this_item_public:
      '¿Estás seguro de que deseas hacer público este elemento? Se copiará en tu biblioteca pública.',
    move_to_organization: 'Mover a la organización',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      '¿Estás seguro de que deseas copiar este elemento a la biblioteca de tu organización?',
    are_you_sure_you_want_to_make_this_item_private:
      '¿Estás seguro de que deseas hacer privado este elemento? Se copiará en tu biblioteca personal.',
    date_modified: 'Fecha de modificación',
    workflow_management: 'Gestión de flujo de trabajo',
    configure_editors_approvers_and_viewers_for_this_document:
      'Configura editores, aprobadores y espectadores para este documento.',
    error_Loading_editor: 'Error al cargar el editor',
    debug_info: 'Información de depuración',
    loading_editor: 'Cargando editor...',
    submitted_for_review: 'Enviado para revisión',
    editors: 'Editores',
    no_editors_added_yet:
      'Aún no se han agregado editores. Haz clic en "Agregar editor" para agregar uno.',
    add_editor: 'Agregar editor',
    approvers: 'Aprobadores',
    no_approvers_added_yet:
      'Aún no se han agregado aprobadores. Haz clic en "Agregar aprobador" para agregar uno.',
    add_approvers: 'Agregar aprobador',
    viewer: 'Espectador',
    no_viewers_added_yet:
      'Aún no se han agregado espectadores. Haz clic en "Agregar espectador" para agregar uno.',
    add_viewer: 'Agregar espectador',
    are_you_sure_you_want_to_delete_the_selected_items:
      '¿Estás seguro de que deseas eliminar los elementos seleccionados?'
  },
  v3: {
    reportShareSphere: 'Esfera Compartida',
    overview: 'Resumen de la categoría',
    triviaReport: 'Categoría ShareSphere',
    overviewGraph: 'Gráfico de resumen de la categoría',
    category: 'Categoría',
    phCategory: 'Selecciona una categoría',
    podcast: 'Podcast, música e historias',
    pastPodcast: 'Podcasts anteriores',
    upcomingPodcast: 'Próximos podcasts',
    podcastLanguageTitle: 'Idioma del podcast, música e historias',
    podcastLanguageCheckbox: 'Usar IA para el idioma de mi podcast',
    howRate: '¿Cómo calificas este podcast?',
    podcastSubmit: 'Enviar',
    podcastGuest: 'Invitado:',
    podcastReview: 'Reseñas',
    podcastEpishode: 'Episodio',
    podcastEnd: 'Podcast finalizado',
    date_podcast: 'Fecha del podcast',
    skill_not_found: '¡Lo sentimos! Ruta de habilidades no encontrada.',
    coaching: 'Entrenamiento',
    webinar: 'Webinario',
    public_conference: 'Conferencia pública',
    skill_journey_subtitle:
      'Configura tu ruta de habilidades y elige quién puede verla e interactuar con ella.',
    enable_white_label: 'Habilitar marca blanca',
    create_new_event_org: 'Crear un nuevo evento para tu organización',
    create_new_event_marketplace: 'Crear un nuevo evento para el marketplace',
    create_new_event_both:
      'Crear un nuevo evento para tu organización y el marketplace',
    event_outline: 'Ingresa el esquema del evento',
    event_obj: 'Ingresa los objetivos del evento',
    event_description: 'Ingresa la descripción del evento',
    create_new_metamaze_org: 'Crear un nuevo MetaMaze para tu organización',
    create_new_metamaze_marketplace:
      'Crear un nuevo MetaMaze para el marketplace',
    create_new_metamaze_both:
      'Crear un nuevo MetaMaze para tu organización y el marketplace',
    add_key_words: 'Agregar palabras clave',
    press_enter_make_keyword: 'Presiona Enter para crear una palabra clave',
    disable_skip_quiz: 'Desactivar omitir cuestionario',
    warning_complete_quiz:
      'Por favor, completa el cuestionario para continuar.',
    signup_email_verification:
      'Hemos enviado un enlace de confirmación a tu correo electrónico. Por favor, haz clic en él para confirmar tu registro.',
    verifying_registration: 'Verificando el registro...',
    reset_password_linK:
      'Hemos enviado un enlace para restablecer la contraseña a tu correo electrónico. Haz clic en el enlace para crear una nueva contraseña.',
    reset_email_error:
      'Usuario con ese correo no encontrado, ¡intenta con tu nombre de usuario!',
    first_name: 'Nombre',
    last_name: 'Apellido',
    error_firstName: 'Por favor, ingresa tu nombre',
    error_sharebot_organization: 'Por favor, ingresa la organización',
    error_lastName: 'Por favor, ingresa tu apellido',
    private_conference: 'Conferencia privada',
    public_conference: 'Conferencia pública',
    discussion_room: 'Sala de discusión',
    training_no_courses: 'Actualmente no estás inscrito en ningún curso.',
    training_no_events: 'Actualmente no estás participando en ningún evento.',
    allow_sharing_trainer_info:
      'Permitir que el marketplace comparta el correo electrónico',
    error_username_space: 'El nombre de usuario no puede contener espacios.',
    error_sharebot_organization_space:
      'El nombre de la organización no puede contener espacios.',
    edit_permission: 'Permiso para editar',
    valid_price: 'El precio debe ser mayor que 0',
    course_price_message: `*Los cursos están disponibles solo para usuarios que los compraron a través de la organización y no se pueden revender en el marketplace`,
    valid_edit_price:
      'El precio de edición debe ser menor al precio de compra.',
    my_calendar: 'Mi calendario',
    error_valid_firstName: 'Por favor, ingresa un nombre válido.',
    error_valid_organization:
      'Por favor, ingresa un nombre de organización válido.',
    error_valid_lastName: 'Por favor, ingresa un apellido válido.',
    error_name_spaces: 'El nombre no debe contener espacios',
    items: 'Artículos',
    publish_to_channel: 'Publicar en mi colección de canales',
    create_a_channel: 'Crear mi canal',
    create_a_trivia: 'Crear un cuestionario',
    create_a_new_channel: 'Crear un nuevo canal',
    add_videos: 'Agregar videos',
    save_and_continue: 'Guardar y continuar',
    channel: 'Canal',
    channels: 'Canales',
    view_channel: 'Ver canal',
    edit_channel: 'Editar canal',
    delete_channel: 'Eliminar canal',
    my_video_channels: 'Mis canales de video',
    training_no_channel: 'Actualmente no estás participando en ningún canal.',
    monthly_price_required: 'Se requiere un precio mensual',
    yearly_price_required: 'Se requiere un precio anual',
    one_time_price_required: 'Se requiere un precio único',
    marketplace_quantity: 'Dólares',
    report_webinar: 'Webinario',
    report_coaching: 'Entrenamiento',
    report_channel: 'Canal',
    report_public_conference: 'Conferencia pública',
    report_maze: 'Laberinto',
    channel: 'Canal',
    edit_price: 'Editar precio ($)',
    quantity: 'Cantidad',
    payment_type: 'Tipo de pago',
    total_amount: 'Monto total ($)',
    net_amount: 'Monto neto ($)',
    edit_option: 'Editar opción',
    marketplace_price: 'Precio ($)',
    market_name: 'Nombre',
    duration_min: 'Duración (min)',
    users_total: 'Usuarios (total)',
    sales_total: 'Ventas totales (USD)',
    search_coaching: 'Buscar entrenamiento',
    search_channel: 'Buscar canal',
    search_webinar: 'Buscar webinario',
    search_maze: 'Buscar laberinto',
    search_public_conference: 'Buscar conferencia pública',
    buyer_type: 'Tipo de comprador',
    quanity: 'Cantidad',
    channel_unit_amount: 'Monto neto ($)',
    channel_updated_at: 'Actualizado',
    month_price: 'Precio (mensual)',
    year_price: 'Precio (anual)',
    one_time_price: 'Precio (único)',
    sharebot_organization: 'Agregar nuevo nombre de organización',
    share_sphere: 'Esfera compartida',
    ai_course_title: 'Título del Curso',
    ai_input_course_title: '¡Por favor, ingresa el título del curso!',
    learning_objective_label: 'Objetivo de Aprendizaje',
    learning_objective_message:
      '¡Por favor, ingresa el objetivo de aprendizaje!',
    standard_question: '¿Existe algún estándar que el estudiante deba seguir?',
    standard_details_label: 'Detalles del Estándar',
    standard_details_message: '¡Por favor, ingresa los detalles del estándar!',
    estimated_duration_label: 'Duración Estimada del Curso (en minutos)',
    estimated_duration_message: '¡Por favor, ingresa la duración estimada!',
    min_duration_message: 'La duración mínima es de 5 minutos.',
    ai_mins: '25 minutos',
    industry_specific_question: '¿Está dirigido a una industria específica?',
    industry_label: 'Especificar Industria',
    industry_message: '¡Por favor, ingresa la industria!',
    ai_course_creation: 'Creación de Curso con IA',
    course_generated: 'Curso Generado por Sharelook',
    ai: 'IA',
    ai_you: 'Tú',
    ai_prompt_ready:
      'Tu solicitud está lista. Ahora puedes generar la tabla de contenido.',
    ai_unable_respond:
      '¡Lo sentimos! La IA no puede responder a tu solicitud. Por favor, intenta de nuevo.',
    ai_hide_toc: 'Ocultar Tabla de Contenido',
    ai_preview_toc: 'Vista Previa de la Tabla de Contenido',
    ai_generate_toc_now: 'Generar Tabla de Contenido Ahora',
    ai_creation_course_title: 'Título del Curso:',
    ai_creation_industry_specific: '¿Está Dirigido a una Industria Específica:',
    ai_creation_industry: 'Industria:',
    ai_creation_standard_needed:
      '¿Hay Algún Estándar que el Estudiante Deba Seguir?:',
    ai_creation_standard_details: 'Detalles del Estándar:',
    ai_creation_estimated_duration: 'Duración Estimada del Curso (en Minutos):',
    minutes: 'minutos',
    ai_creation_learning_objective: 'Objetivo de Aprendizaje:',
    setup_again: 'Configurar de Nuevo',
    ai_creation_confirm_title:
      '¿Estás seguro de que deseas volver a configurar el formulario?',
    ai_creation_confirm_content:
      'El chat y todo el contenido que hayas generado se restablecerán.',
    ai_toc: 'Tabla de Contenido',
    ai_note_topic:
      'Nota: Puedes arrastrar y soltar para reordenar los temas dentro de la lección.',
    ai_add_topic: '+ Agregar Tema',
    add_topic: 'Agregar Tema',
    add_lesson: 'Agregar Lección',
    add_new_lesson: 'Agregar Nueva Lección',
    ai_add_lesson: '+ Agregar Lección',
    attention: 'Atención',
    before_varifying: 'Antes de Verificar',
    ai_save_later: 'Guardar para Más Tarde',
    ai_download_word_doc: 'Descargar como Documento Word',
    ai_download_course_word_doc: 'Descargar Curso como Documento Word',
    ai_create_course_button: 'Crear Curso',
    ai_generate_course_content: 'Generar Contenido del Curso',
    ai_out_of: 'de',
    ai_subtopic_failed_content:
      'algunos subtemas no generaron contenido. Haz clic en "Generar Contenido del Curso" de nuevo para generarlo solo para esos subtemas.',
    ai_edit_topic: 'Editar Tema',
    ai_edit_lesson_title: 'Editar Título de la Lección',
    ai_save_topic: 'Guardar Tema',
    ai_save: 'Guardar',
    ai_save_lesson_title: 'Guardar Título de la Lección',
    ai_add_new_topic: 'Agregar Nuevo Tema',
    ai_download_ref: 'Descargar con Referencias',
    ai_download_ref_content:
      'Se descargará el curso como un documento Word con referencias.',
    ai_download_without_ref: 'Descargar sin Referencias',
    ai_download_two_word: 'Se descargarán dos documentos Word:',
    ai_download_two_word_content_one:
      '- uno que contiene el contenido principal sin referencias,',
    ai_download_two_word_content_two:
      'y otro que consiste únicamente en una lista de referencias sin contenido adicional.',
    ai_manage_content: 'Administrar Contenido',
    ai_add_content_from_internet: '+Agregar Contenido de Internet',
    ai_confirm_start: 'Confirmar Inicio',
    ai_Verify: 'Verificar',
    ai_undo_warning:
      'Este proceso puede tomar algún tiempo. No cierres esta ventana hasta que finalice, ya que no se puede deshacer.',
    ai_verified_content:
      'Has verificado el contenido. Ten en cuenta que, después de confirmar, no podrás volver al chat con el asistente de IA con el contenido actual.',
    ai_want_proceed: '¿Estás seguro de que deseas continuar?',
    upload_simulation: 'Cargar Simulación',
    name_simulation: 'Nombre de la Simulación',
    selected_simulation_files: 'Archivos de Simulación Seleccionados',
    score_between_one_hundred: 'Tu puntuación debe estar entre 1 y 100.',
    are_sure_simulation:
      '¿Estás seguro de que deseas eliminar este archivo de simulación?',
    required_simulation: 'Se requiere puntuación',
    required_section_file: 'Se requiere archivo de sección',
    simulation: 'Simulación',
    simulation_quiz_games: 'Se debe agregar un cuestionario en los juegos',
    simulation_alert_des:
      'Solo puedes agregar juegos si todas las preguntas tienen tipo de respuesta única o múltiple.',
    alert_info: 'info',
    ai_number_quiz: 'Número de Cuestionarios',
    ai_point: 'Punto',
    ai_points: 'Puntos',
    val_required: 'Requerido',
    games: 'Juegos',
    add_simulation: 'Agregar Simulación',
    text_tiewer: 'Visor de Texto',
    back_to_account: 'Volver a la Cuenta',
    delete_account: 'Eliminar Cuenta',
    delete_account_title: '¿Eliminar Cuenta?',
    delete_account_subtitle: 'Puedes eliminar tu cuenta desde aquí.',
    delete_account_cannot_undo:
      'Estás a punto de eliminar tu cuenta. Esta acción no se puede deshacer.',
    account_org_profile:
      'También perderás todos los cursos creados, el perfil de tu organización y toda tu configuración.',
    deleting_account_database:
      'Eliminar tu cuenta eliminará todos tus datos de nuestra base de datos.',
    account_confirm_delete: '¿Estás seguro de que deseas eliminar tu cuenta?',
    action_cannot_be_undone: 'Esta acción no se puede deshacer.',
    account_delete_message_success: 'Tu cuenta ha sido eliminada exitosamente.',
    message_edit: 'Editar',
    message_delete: 'Eliminar',
    message_reply: 'Responder',
    attached_file: 'Archivo Adjunto',
    attach_file: 'Adjuntar Archivo',
    attach_des: '25 MB, tamaño máximo de archivo',
    view: 'Ver',
    go_to_marketplace: 'Ir al Marketplace',
    learning_center: 'Centro de Aprendizaje',
    knowledge_center: 'Centro de Conocimiento',
    sharebot: 'ShareBot',
    sharebot_help_message: '¿Cómo puedo ayudarte hoy?',
    my_organization: 'Mi Organización',
    world_knowledge: 'Conocimiento Global',
    welcome_to_sharelook: '¡Bienvenido a Sharelook!',
    sharelook_you_want_go: '¿A dónde quieres ir hoy?',
    shareLook_learning_management_system:
      'Accede al sistema de gestión de aprendizaje de ShareLook para crear o acceder a recursos de aprendizaje como eventos en vivo y cursos dentro de tu organización en ShareLook.',
    shareLook_powerful_ai_system:
      'Accede al potente sistema impulsado por IA de ShareLook, donde puedes subir documentos PDF y obtener información útil al instante. Obtén respuestas rápidas basadas en los recursos de tu organización o desde nuestro sistema genérico en la sección de conocimiento global.',
    edit_now: 'Editar Ahora',
    sharelook_log_out:
      'Has cerrado sesión en Sharelook. ¡Por favor inicia sesión!',
    sorry_error: '¡Lo sentimos! Ocurrió un error.',
    login: 'Iniciar Sesión',
    refresh_page: 'Actualizar Página',
    just_a_moment: 'Un Momento',
    enter_lname_fname: 'Por favor ingresa tu nombre y apellido para continuar.',
    procced_to_sharelook: 'Ir a Sharelook',
    option_one: 'Opción 1',
    option_two: 'Opción 2',
    selected_image: 'Imagen Seleccionada:',
    add_text: 'Agregar Texto',
    linkdin_is_required: 'LinkedIn es requerido.',
    bio_is_required: 'La biografía es requerida.',
    save_user_information: 'Guardar Información del Usuario',
    select_all: 'Seleccionar Todo',
    enable_ai: 'Habilitar IA',
    load_more: 'Cargar Más',
    channel_id: 'ID del Canal',
    send: 'Enviar',
    v4: 'Información',
    subscription: 'Suscripción',
    reset_user_flag: 'REINICIAR BANDERA DE USUARIO',
    delete_my_accont: 'Eliminar mi cuenta',
    sharebot_sub_error: 'Error al obtener suscripciones. ¡Inténtalo de nuevo!',
    sharebot_no_sub: 'Actualmente no tienes suscripciones activas.',
    sharebot_dont_sub: 'No tienes suscripciones anteriores.',
    sharebot_prev_sub: 'Suscripciones Anteriores',
    sharebot_sub: 'Suscripción a ShareBot',
    sharebot_un_sub: 'Cancelar Suscripción a ShareBot',
    sharebot_no_available: 'No hay Descripción Disponible',
    sharebot_start_date: 'Fecha de Inicio:',
    sharebot_end_date: 'Fecha de Fin:',
    sharebot_sure: '¿Estás seguro?',
    sharebot_do_you_want: '¿Deseas',
    unsubscribe: 'cancelar la suscripción',
    unsubscribe_what: '¿cancelar la suscripción?',
    subscribe: 'suscribirte',
    subscribe_what: '¿suscribirte?',
    subscribe_now: 'Suscribirte Ahora',
    confirm: 'Confirmar',
    sharebot_intel_knowledge_center:
      'Centro de Conocimiento Inteligente de ShareBot',
    sharebot_welcome_paragraph:
      'Bienvenido al Centro de Conocimiento de ShareBot, el avanzado chatbot de IA diseñado para transformar cómo los profesionales acceden a la información y colaboran.',
    expired: 'Expirada',
    active: 'Activa',
    Inactive: 'Inactiva',
    yearly_subscription: 'Suscripción Anual',
    monthly_subscription: 'Suscripción mensual',
    no_sharebot_org: 'No tienes una organización de ShareBot',
    sharebot_start_free_trial: 'Comenzar prueba gratis',
    sub_month: 'Suscripción mensual',
    sub_year: 'Suscripción anual',
    question_per_month:
      'Almacenamiento de datos (1TB) y 1000 preguntas por mes',
    sharebot_para:
      'Al continuar, confirmas la eliminación inmediata de la organización. Esta acción resultará en la pérdida de todos los conocimientos valiosos proporcionados por ShareBot y no se puede deshacer.',
    cancelled_date: 'Fecha de cancelación:',
    live_straming_para:
      'Si deseas cambiar tu límite mensual de transmisión en vivo, por favor contacta a',
    sharelook_agree: 'Acepto los',
    terms_condition: 'términos y condiciones',
    and: 'y',
    privacy_policy: 'política de privacidad',
    save_for_later: 'Guardar para después',
    ai: 'IA',
    no_video_yet: '¡Aún no se han seleccionado videos!',
    are_you_sure_delete_video:
      '¿Estás seguro de que deseas eliminar este video?',
    video_des: 'Descripción',
    video_now: 'Ahora',
    video_playing: 'Reproduciendo:',
    video_no: 'Video No.',
    ai_generated_course: 'Curso generado por IA',
    create_course_on_our_own: 'Crear un curso por tu cuenta',
    ai_Assisted_ourse_reation: 'Creación de curso asistida por IA',
    pending: 'Pendiente',
    published: 'Publicado',
    intro_course: '¿en tu curso?',
    clone_course: '¿Te gustaría clonar',
    browser_audio_not_support: 'Tu navegador no admite la etiqueta de audio.',
    audio_popup_content:
      'Aquí puedes usar varios estilos de voz sobre el texto que escribas. Bla bla bla. Lorem Ipsum es simplemente texto ficticio de la industria de impresión y composición tipográfica. Lorem Ipsum ha sido el texto estándar ficticio desde el siglo XVI.',
    close: 'Cerrar',
    podcast_rec: 'GRABAR',
    create_podcast: 'Crear podcast',
    add_admin: 'AGREGAR ADMIN',
    delete_all: 'Eliminar todo',
    ai_podcast_audio: 'Audio de podcast IA',
    language: 'Idioma',
    podcast_download_content:
      '*Descarga el archivo de audio generado por IA para editarlo como tu propio archivo de audio.',
    upload_audio: 'Subir audio',
    browser_do_not_support_audio:
      'Tu navegador no admite el elemento de audio.',
    upload_cover: 'Subir portada',
    upload_ai_creator: 'Creador IA',
    required_cover_image: '¡Se requiere una imagen de portada!',
    room_required_name: '¡Se requiere el nombre del podcast!',
    add_guest_list: '¡Por favor agrega la lista de invitados!',
    podcast_add_participants: 'AGREGAR PARTICIPANTE',
    topic_required: 'Se requiere al menos un tema',
    podcast_description: 'DESCRIPCIÓN',
    podcast_date: 'FECHA',
    date: 'Fecha',
    podcast_time: 'hora',
    podcast_to: 'a',
    podcast_all_day: 'Todo el día',
    podcast_start_date_time: '¡Se requiere fecha y hora de inicio!',
    podcast_id: 'ID',
    selected_user: 'Invitar usuarios seleccionados',
    see_more: 'Ver más',
    see_less: 'Ver menos',
    no_review_yet: 'Aún no hay reseñas, sé el primero en opinar.',
    request_to_speak: '¿Aceptar la solicitud del usuario para hablar?',
    kick_user: '¿Deseas expulsar a este usuario?',
    accept_request: 'Aceptar solicitud',
    kick: 'EXPULSAR',
    started: 'INICIADO',
    end: 'FINALIZADO',
    join_now: 'Unirse ahora',
    podcast_end: 'El podcast ha terminado',
    connecting: 'conectando...',
    knowledge_center_know_today: '¿Qué te gustaría saber hoy?',
    knowledge_center_question: 'Por favor, ingresa una pregunta primero',
    knowledge_center_error: '¡Lo sentimos! Se produjo un error.',
    knowledge_center_tooltrip:
      'Obtén respuestas rápidas desde los recursos de aprendizaje en el repositorio de tu organización en ShareLook, con referencias adecuadas y la posibilidad de previsualizar y descargar documentos PDF.',
    my_organization: 'Mi organización',
    world_knowledge: 'Conocimiento global',
    open_file: 'Abrir archivo',
    reference: 'Referencia',
    are_you_cancel: '¿Estás seguro de que deseas cancelar?',
    are_you_remove_media:
      '¿Estás seguro de que deseas eliminar este archivo multimedia?',
    terms_agree: 'Acepto estos',
    ready: 'Listo',
    send_email: 'ENVIAR CORREO',
    active_users: 'Usuarios activos',
    sign_up_user: 'Usuarios registrados',
    non_sign_up_user: 'Usuarios no registrados',
    organisation: 'Organización',
    usage_report: 'Informe de uso',
    check_email: 'revisa tu correo',
    delete_schedule: 'Eliminar programación',
    are_you_sure_delete_schedule:
      '¿Estás seguro de que deseas eliminar esta programación?',
    add_task: '¡Por favor ingresa una tarea!',
    coaching_available: 'Marcar como disponible para coaching',
    message_booking_coaching:
      'Este horario ha sido reservado por un usuario para coaching.',
    task_day: 'Día de tarea',
    created_task_day: 'Has creado una tarea para este día.',
    event_day: 'Día de evento',
    has_booked_coaching: 'Se ha reservado un coaching para este día.',
    active_day: 'Día activo',
    selectable_time_slots:
      'Las franjas horarias seleccionables a la derecha están activas para este día.',
    compare_last_month: 'Comparado con el mes pasado',
    uploading_file: 'Subiendo tu archivo',
    attach_file_course: 'adjunto a este curso.',
    fetch_request: 'Procesando tu solicitud',
    finilize_upload: 'Finalizando la carga',
    scorm_scanned: 'Por favor espera... Tu archivo SCORM se está escaneando.',
    scan_status: 'Estado del escaneo:',
    scan_completed: 'Escaneo completado. Tu archivo está',
    scan_progress: 'Escaneo en progreso...',
    check_scorm:
      'Comprobando el formato del archivo SCORM... Por favor espera...',
    file_check_success: 'Verificación de archivo exitosa',
    file_check_progress: 'Verificación de archivo en progreso...',
    scorm_not_upload:
      'Tu archivo no cumple con el estándar SCORM 1.2. Por favor sube un archivo compatible.',
    select_question: 'Opciones de respuesta (selecciona una correcta)',
    select_answer: '¡Por favor selecciona una opción de respuesta!',
    check_option_one: '¡Por favor ingresa la opción uno!',
    check_option_two: '¡Por favor ingresa la opción dos!',
    check_option_three: '¡Por favor ingresa la opción tres!',
    check_option_four: '¡Por favor ingresa la opción cuatro!',
    question_image: 'Imagen de la pregunta',
    select_question_image: '¡Por favor selecciona una imagen de pregunta!',
    ans_image: 'Imagen de respuesta',
    upload_image_question: 'Subir imagen de respuesta',
    select_image_answer: '¡Por favor selecciona una imagen de respuesta!',
    save_question: 'Guardar pregunta',
    do_you_leave: '¿Estás seguro de que deseas salir?',
    loose_all_progress: 'Perderás todo tu progreso.',
    welcome: 'Bienvenido',
    team_knowledge_quest: 'Búsqueda de conocimiento en equipo',
    your_score: 'Tu puntuación',
    start_playing: 'Comenzar a jugar',
    share_sphere_complete: 'ShareSphere completado',
    final_score: 'Puntuación final',
    play_next: 'Jugar siguiente',
    you_donot_access_event: 'No tienes acceso a este evento.',
    ai_content_generated: 'El contenido ha sido generado para este tema.',
    ai_popup_confirm_content: 'Confirmar generación de contenido',
    limit_transcribe_text:
      'Minutos restantes de transcripción: <0>{{ transcribe_limit }}</0> minutos <1/><2/> <3>. Para cambiar tu límite de transcripción, por favor contacta a </3> <4>admin@sharelook.com</4>.',
    monthly_ai_credit_limit: 'Para cambiar su límite de créditos de IA, por favor contacte a',
    remaining_credits_text: 'Créditos de IA restantes: <0>{{ remaining_credits }}</0> créditos <1/><2/> <3>. Para cambiar su límite de créditos de IA, por favor contacte a </3> <4>admin@sharelook.com</4>.',
    you_donot_access_event: 'No tienes acceso a este evento.',
    ai_course_title_training: 'Cursos de capacitación en liderazgo',
    ai_course_object: 'Liderazgo en la era digital',
    create_ai_video: 'Crear video con IA',
    generate: 'GENERAR',
    video_generate_process:
      'El proceso de generación del video puede tardar un poco. Recibirás un correo electrónico cuando esté listo.',
    stripe_account_connect:
      'Tu cuenta de Stripe está inactiva. Por favor conéctala o actívala para continuar.',
    ai_creator: 'Creador con IA',
    check_video_status: 'Verificando el estado de la generación del video...',
    video_on_queue: 'El video está en la cola de generación.',
    video_fail_generation:
      'Lo sentimos, la generación del video falló. Por favor intenta con otro.',
    video_currently_generated: 'Este video se está generando actualmente.',
    checking_status: 'Verificando estado',
    check_status: 'Verificar estado',
    browser_does_not_support_audio:
      'Tu navegador no admite la etiqueta de audio',
    existing_edit_scenario:
      '¿Quieres editar el escenario existente o crear uno nuevo? Si creas uno nuevo, se perderá el anterior.',
    generate_scenario: 'Generar escenario',
    layout: 'Diseño',
    confirm_change: 'Confirmar cambio',
    generated_ai_creation_message:
      'Ten en cuenta que solo se conservarán los elementos de texto generados por IA. Todos los demás serán eliminados de la página.',
    generate_story: 'Generar historia',
    save_original_content: 'Guardar contenido original:',
    story_added_specified_position:
      'La posición de la historia en la lección. Se añadirá como un bloque en la posición indicada.',
    position_of_story: 'Posición de la historia',
    start_the_lesson: 'Inicio de la lección',
    end_the_lesson: 'Fin de la lección',
    add_story_pages: 'Agregar historia a las páginas',
    browser_does_not_support: 'Tu navegador no admite el elemento de audio.',
    no_video_available: 'No hay videos disponibles.',
    no_podcast_available: 'No hay pódcast disponibles.',
    no_item_baskets: 'No hay artículos en la cesta.',
    ai_course_object: 'Liderazgo en la era digital'
  },
  v2: {
    n_data: 'Sin datos',
    change: 'Cambiar',
    remove: 'Eliminar',
    auto_background: 'Fondo automático',
    create_new_course_org: 'Crea un nuevo curso para tu organización.',
    create_new_course_marketplace: 'Crea un nuevo curso para el marketplace.',
    create_new_course_both:
      'Crea un nuevo curso para tu organización y el marketplace.',
    ok: 'Ok',
    page_bg: 'Fondo de página',
    lesson_cover: 'Imagen de portada de lección',
    create_skill_journey: 'Crear un recorrido de habilidades',
    Metamaze: 'Metamaze',
    events: 'Eventos',
    scroms: 'SCORMs',
    min_score_pass: 'Puntaje mínimo para aprobar',
    no_scorms_available: 'No hay SCORMs disponibles.',
    no_events_available: 'No hay eventos disponibles.',
    no_courses_available: 'No hay cursos disponibles.',
    no_courses_baskets: 'No hay cursos en el carrito.',
    no_mazes_baskets: 'No hay laberintos en el carrito.',
    no_scroms_baskets: 'No hay SCORMs en el carrito.',
    no_events_baskets: 'No hay eventos en el carrito.',
    sorry: '¡Lo sentimos!',
    option_1: 'Opción 1',
    option_2: 'Opción 2',
    enter_number_words: 'Ingresa el número máximo de palabras.',
    summarize: 'Resumir',
    answer: 'Responder',
    hold_tight_one_minute:
      '¡Espera un momento! Aún estamos preparando todo. Esto puede tardar hasta un minuto.',
    enter_question: 'Ingresa tu pregunta.',
    enter_relevant_documents: 'Ingresa el número de documentos relevantes.',
    please_input_relevant_documents:
      '¡Por favor ingresa el número de documentos relevantes!',
    please_wait_loading_results:
      'Por favor espera mientras se cargan los resultados...',
    proceed_to_add_voice: 'Proceder a agregar voz',
    results: 'Resultados',
    no_result_found_try_asking_questions:
      'No se encontraron resultados. Intenta hacer más preguntas.',
    eg: 'ej.,',
    what_make_sales_manager: '¿Qué puede convertirme en un gerente de ventas?',
    please_select_lang: '¡Por favor selecciona un idioma!',
    search: 'Buscar',
    please_copy_desired_content:
      'Por favor copia el contenido deseado del cuadro izquierdo al cuadro derecho.',
    rating_req: 'La calificación es un campo obligatorio.',
    review_req: 'La reseña es un campo obligatorio.',
    rating_review_req:
      'Debes proporcionar tanto una calificación como una reseña.',
    how_rate_this: '¿Cómo calificarías esto?',
    amazing_above_expectations: '¡Increíble! ¡Superó las expectativas!',
    certificates: 'Certificados',
    you_no_certificates: 'No tienes certificados disponibles en este momento.',
    please_add_review:
      'Por favor proporciona una reseña junto con la calificación. ¡Gracias!',
    post: 'Publicar',
    rate: 'Calificar',
    avg_rating: 'Calificación promedio',
    no_review_found: 'No se encontraron reseñas',
    are_sure_to_disale_zoom_integration:
      '¿Estás seguro de que deseas desactivar la integración con Zoom?',
    badges: 'Insignias',
    you_no_badge_available: 'No tienes insignias disponibles en este momento.',
    download_certificate: 'Descargar certificado',
    loading: 'Cargando...',
    no_file_attached: 'No hay archivos adjuntos',
    you_do_not_have_any_notes: 'No tienes notas.',
    question: 'Pregunta',
    score: 'Puntaje',
    alert_score_message: 'Una o más personas han enviado sus puntajes.',
    alert_question_message: 'Todavía no se han agregado preguntas.',
    button_submit: 'Enviar',
    button_allScores: 'Todos los puntajes han sido enviados.',
    record_wait: 'La grabación está comenzando. Por favor espera...',
    buttonSubmit_warning:
      'Por favor completa todos los puntajes antes de enviar.',
    upload_ar_assets: 'Subir recursos AR',
    edit_ar_assets: 'Editar recursos AR',
    edit_maze_assets: 'Editar recursos MetaMaze',
    upload_assets: 'Subir recursos',
    upload_maze_assets: 'Subir recursos MetaMaze',
    trigger_title: 'Título del disparador',
    model_title: 'Título del modelo',
    trigger_description: 'Descripción del disparador',
    model_description: 'Descripción del modelo',
    please_type_target_description:
      'Por favor, escribe la descripción del objetivo.',
    please_type_model_description:
      'Por favor, escribe la descripción del modelo.',
    trigger_image: 'Imagen del disparador*',
    model_image: 'Imagen del modelo*',
    upload_trigger_image: 'Subir imagen del disparador',
    upload_model_image: 'Subir imagen del modelo',
    drag_n_drop: 'Arrastrar y soltar',
    file_size_should_not_exceed:
      '(El tamaño del archivo de imagen (JPEG) no debe superar los 512 KB)',
    zip_size_should_not_exceed:
      '(El tamaño del archivo ZIP no debe superar los 60 MB)',
    ar_content: 'Contenido AR*',
    model_content: 'Modelo 3D*',
    upload_3d_zip: 'Subir ZIP / Video',
    upload_3d_maze_zip: 'Subir ZIP',
    audio_content: 'Contenido de audio',
    _mp3: '(.mp3)',
    content_attached: 'Archivo ZIP adjuntado.',
    video_attached: 'Video adjuntado.',
    audio_attached: 'Audio adjuntado.',
    enter_trigger_image_title:
      'Introduce el título de la imagen del disparador.',
    enter_model_title: 'Introduce el título del modelo MetaMaze.',
    ar_preview_image: 'Imagen previa AR',
    upload_preview_image: 'Subir imagen previa',
    upload_audio: 'Subir audio',
    creating___: 'Creando...',
    updating___: 'Actualizando...',
    create: 'Crear',
    update: 'Actualizar',
    ar_assets: 'Imagen 3D',
    _3d_files_mp4: '(Archivos .obj, .fbx comprimidos o video .mp4)',
    _3d_files_mp4_ar: '(Archivos .obj, .fbx comprimidos)',
    maze_3d_files_mp4: '(Archivos .obj, .fbx comprimidos)',
    _jpg_files: 'Solo se admiten archivos .jpg',
    persons_have_submitted_their_scores:
      'Persona(s) han enviado sus puntuaciones.',
    no_questions_added_till_now: 'No se han añadido preguntas aún.',
    submit: 'Enviar',
    all_scores_submitted: 'Todas las puntuaciones han sido enviadas.',
    recording_is_starting: 'La grabación está comenzando. Por favor espera...',
    please_input_scores_before_submitting:
      'Por favor, introduce todas las puntuaciones antes de enviar.',
    end_for_all: 'Finalizar para todos',
    full_screen: 'Pantalla completa',
    breakout_room: 'Sala de reuniones',
    send_invitations: 'Enviar invitación(es)',
    add_participants: 'Añadir participante(s)',
    create_breakout_room: 'Crear sala de reuniones',
    connecting: 'Conectando...',
    currently_broadcaster_unavailable:
      'Actualmente, el transmisor no está disponible.',
    how_many_breakout_room_to_create:
      '¿Cuántas salas de reuniones deseas crear?',
    create_upto_three_breakout_rooms: '*Crear hasta 3 salas de reuniones',
    allow: 'Permitir',
    additional: 'Adicional',
    attachment: 'Archivos adjuntos',
    no_description_available: 'No hay descripción disponible.',
    people: 'PERSONAS',
    waiting: 'Esperando',
    hand_raising_users: 'Usuarios levantando la mano',
    invite: 'Invitar',
    create_room: 'Crear sala',
    create_live_event: 'Crear evento en vivo',
    support_upto_fivethousand_participants:
      'Soporta hasta 5,000 participantes para el evento',
    support_upto_ten_participants:
      'Soporta hasta 10 participantes con video en vivo',
    support_upto_twohundred_participants:
      'Soporta hasta 200 participantes para el evento',
    supprt_upto_five_participants:
      'Soporta hasta 5 participantes con video en vivo',
    support_upto_twentyfive_participants:
      'Soporta hasta 25 participantes con video en vivo para el evento',
    two_live_video_participants:
      'Hay 2 participantes con video en vivo para el evento (anfitrión y asistente)',
    you_can_have_upto_five_examinees: 'Solo puedes tener hasta 5 examinados.',
    you_can_have_upto_twentyfive_participants:
      'Solo puedes tener hasta 25 participantes.',
    you_can_have_upto_five_participants:
      'Solo puedes tener hasta 5 participantes.',
    you_can_have_upto_ten_participants:
      'Solo puedes tener hasta 10 participantes.',
    select_hosts_email: 'Selecciona el correo electrónico del anfitrión',
    send_invite_email: 'Enviar correo de invitación',
    do_not_send_invite_email: 'No enviar correo de invitación',
    error: 'Error',
    max_twentyfive_users_allowed:
      'Máximo 25 usuarios permitidos para seleccionar',
    max_five_users_allowed: 'Máximo 5 usuarios permitidos para seleccionar',
    max_ten_users_allowed: 'Máximo 10 usuarios permitidos para seleccionar',
    no_user_found: 'No se encontraron usuarios',
    transcribe_to: 'Transcribir a',
    integrate_zoom_to_start_meeting:
      'Integra Zoom en tu cuenta para iniciar una reunión de Zoom.',
    zoom_is_not_integrated: 'Zoom no está integrado.',
    delete_poll: 'Eliminar encuesta',
    add_poll: 'Añadir encuesta',
    live_now: '¡EN VIVO!',
    average_rating: 'Calificación promedio',
    review: 'Reseña',
    time_spent: 'Tiempo dedicado',
    total: 'Total',
    mins: 'Minutos',
    no_data: 'No hay datos para este cuestionario.',
    total_score: 'Puntaje Total',
    pass_score: 'Puntaje de Aprobación',
    point: 'Punto',
    wrong: 'Incorrecto',
    response: 'Respuesta',
    submitted: 'Enviado',
    average: 'Promedio',
    total_play: 'Total de Reproducciones',
    view_graph: 'Ver Gráfico',
    time_spent_mins: 'Tiempo Empleado (Minutos)',
    play: 'Reproducir',
    ideal_path: 'Camino Ideal',
    user_incorrect_path: 'Camino Incorrecto del Usuario',
    ideal_path_taken: 'Camino Ideal Tomado por el Usuario',
    scenario: 'Escenario',
    option: 'Opción',
    spend: 'Gasto',
    average_spending_time: 'Tiempo Promedio de Gasto',
    activity_overview: 'Resumen de Actividad',
    live_event: 'Evento en Vivo',
    live_assessment: 'Evaluación en Vivo',
    report_download: 'Descarga de Reporte',
    all_workshops: 'Todos los Talleres',
    overview_average_activity: 'Resumen Promedio de Actividad',
    overview_workshop_graph: 'Gráfico Resumen del Taller',
    mazes: 'Laberintos',
    correct_feedback: 'Retroalimentación Correcta',
    incorrect_feedback: 'Retroalimentación Incorrecta',
    checkin_checkout: 'Registro de Entrada - Salida',
    minutes: 'Minutos',
    incorrect_path: 'Camino Incorrecto',
    answer_not_available: 'Respuesta No Disponible',
    views: 'Vistas',
    item: 'Elemento',
    questions: 'Preguntas',
    total_points: 'Puntos Totales',
    total_attempts: 'Intentos Totales',
    created_date: 'Fecha de Creación',
    host_name: 'Nombre del Anfitrión',
    host_section: 'Sección del Anfitrión',
    choose_products: 'Elegir Productos',
    add_to_basket: 'Agregar al Carrito',
    basket: 'Carrito',
    times: 'Veces',
    scorms: 'SCORMs',
    skill_journey_overview: 'Resumen del Camino de Habilidades',
    how_to_use: 'Cómo Usar',
    live_broadcast_description:
      'HEMOS INTEGRADO VIDEO EN VIVO EN UN CONSTRUCTOR DE CURSOS FÁCIL DE USAR',
    live_broadcast_subdescription:
      'Con el sistema patentado de transmisión en vivo de ShareLook, puedes crear compromiso, automatizar el aprendizaje y maximizar el intercambio de conocimientos.',
    disclaimer: `Garantizo que mi camino de habilidades no:
  - infringirá los derechos de terceros
  - contendrá ninguna ilegalidad, incluyendo difamación, obscenidad, indecencia, lascivia, pornografía, violencia, abuso, insultos, amenazas o contenido discriminatorio, incluso disfrazado con asteriscos
  - contendrá ataques personales contra otras personas
  - contendrá suplantación de otros participantes, figuras públicas o celebridades
  - contendrá grabaciones o información personal de cualquier individuo sin el consentimiento del mismo y no infringirá ninguna regulación de protección de datos en ninguna parte del mundo
  - contendrá cualquier tipo de solicitud comercial o cualquier forma de “spam”`,
    price: 'Precio',
    video_link: 'Enlace de Video',
    category: 'Categoría',
    objectives: 'Objetivos',
    marketplace_description: 'Descripción del Mercado',

    live_discussion: 'DISCUSIÓN EN VIVO',
    poll: 'ENCUESTA',
    hide_grid: 'Ocultar Cuadrícula',
    show_grid: 'Mostrar Cuadrícula',
    stop_screen_share: 'Detener Compartir Pantalla',
    screen_share: 'Compartir Pantalla',
    mute: 'Silenciar',
    unmute: 'Quitar Silencio',
    raise_hand: 'Levantar la Mano',
    waiting__: 'Esperando...',
    audio_active: 'Audio Activo'
  },
  general: {
    save: 'guardar',
    autosaved: 'auto guardado',
    back_to: 'regresar a',
    by: 'por',
    chat: 'chat',
    completed: 'completado',
    canceled: 'Cancelado',
    component: 'Componente',
    confirm: 'Confirmado',
    course: 'Curso',
    skill: 'Viaje de Habilidades',
    maze: 'MetaLaberinto',
    channel: 'Canal',
    podcast: 'Podcast',

    date: 'Fecha',
    details: 'Detalles',
    empty: 'No hay datos',
    enrolled: 'Inscrito',
    free: 'Gratis',
    graph: 'Grafica',
    loading: 'Cargando...',
    lesson: 'lección',
    lessons: 'lecciones',
    live_assessment: 'Evaluación en vivo',
    live_event: 'Evento en vivo',
    no: 'No',
    of: 'De',
    or: 'O',
    organization: 'Organización',
    page: 'Pàgina',
    pages: 'Paginas',
    personal: 'Personal',
    poll: 'Censo',
    rating: 'Raiting',
    reset: 'Reiniciar',
    signin: 'Iniciar Sesión',
    signup: 'Registrarse',
    soon: 'Pronto',
    type: 'Type',
    uploading: 'Subiendo...',
    yes: 'Yes',
    something_went_wrong: 'Algo salió mal!',
    view_all: 'Ver todo',
    upload_successful: 'La subida del archive fue exitosa',
    upload_successful_message:
      'Sus documentos de Excel fueron subidos exitosamente y están siendo procesados. Esto puedo tomar un algo de tiempo.',
    check_email_upload_successful:
      'Por Favor <0>verifique su correo electrónico</0> para el <1>report</1> de la lista de usuarios que fue subida.',
    is_private: 'Privado'
  },

  account: {
    title: 'Cuenta',
    subtitle: 'Maneje sus ajustes e información de su cuenta.',
    saved: 'La cuenta fue cambiada exitosamente'
  },

  assessments: {
    title: 'Evaluaciones',
    subtitle: 'Crear una evaluación',
    finished: 'La evaluación ha terminado',
    countdown: 'La evaluación en vivo será transmitida en',
    create: 'Crear Evaluación',
    list_title: 'Sus Evaluaciones',
    delete_warning: '¿Está seguro de que quiere borrar este artículo?',
    details_title: 'Añadir detalles de evaluación',
    details_subtitle:
      'Nombre su evaluación y dígale a su audiencia lo que deben de esperar aprender de ella.',
    disclaimer: `Yo certifico que mi evaluación no va a:
    - infringir con los derechos de ninguna otra entidad
    - contener ilegalidades incluyendo contenido difamatorio, obsceno, indecente, lascivo, pornográfico, violento, abusivo, insultante, amenazante, o discriminatorio, aunque esté censurado con asteriscos 
    - contener ningún ataque personal a otras personas
    - contener imitaciones de otros participantes, figuras públicas o celebridades
    - contener grabaciones o información personal de ningún individuo sin el consentimiento de dicho individuo y no estará violando ninguna regulación de datos en ninguna parte del mundo
    - contener ninguna solicitación comercial o alguna forma de “spam”'`
  },

  buildersettings: {
    title: 'Ajustes de Publicación',
    subtitle:
      'Añada ajustes a su evento para determinar quién puede ver e interactuar con su evento.'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: 'Añadir',
    add_page: 'Añadir página',
    add_lesson: 'Añadir lecciones',
    add_answer: 'Añadir nueva respuesta',
    add_group: 'Añadir Grupo',
    add_organization: 'Añadir Organización',
    add_question: 'Añadir Pregunta',
    add_quiz: 'Añadir Quiz',
    add_users: 'Añadir Usuarios',
    back: 'Regresar',
    back_to_course: 'Regresar a la visión general del curso',
    back_to_lesson: 'Regresar a la visión general de la lección',
    back_to_media: 'Regresar a la librería multimedia',
    back_to_details: 'Regresar a detalles',
    cancel: 'Cancelar',
    clear: 'Borrar',
    close: 'Cerrar',
    clone: 'Clonar',
    close_lesson: 'Cerrar Lección',
    clone_course: 'Clonar Curso',
    confirm: 'Confirmar',
    create: 'Crear',
    download: 'Descargar',
    download_mass_user_tamplate: 'Descargar Plantilla',
    add_mass_users: 'Añadir Usuarios en Masa',
    upload_excel_list: 'Subir Lista de Excel',
    delete: 'Borrar Media',
    edit: 'Editar',
    edit_course: 'Editar Curso',
    enroll: 'Inscribirse',
    finish: 'Terminar',
    upload_image: 'Subir Imagen',
    upload_image_video: 'Subir imagen o video',
    select_media_library: 'Seleccionar librería multimedia',
    make_public: 'Hacer Publico',
    make_private: 'Hacer Privado',
    make_org: 'Hacer Organización',
    media: 'Librería Multimedia',
    my_theme: 'Mi tema',
    next: 'Próximo',
    next_lesson: 'Next Lesson',
    next_step: 'Próximo paso',
    previous_step: 'Paso Anterior',
    publish: 'Publicar',
    publish_assessment: 'Publicar su evaluación',
    publish_course: 'Publicar su curso',
    publish_event: 'Publicar su evento',
    reset: 'Reset',
    reset_elements: 'Reset elements',
    save: 'Guardar',
    creating: 'Creando...',
    updating: 'Actualizando...',
    saved: 'Guardado',
    save_for_later: 'Guardar para después',
    save_settings: 'Guardar ajustes',
    select_files: 'Seleccionar archivos',
    select_theme: 'Seleccionar tema',
    start_lesson: 'Comenzar Lección',
    update: 'Actualizar',
    upload: 'Subir',
    upload_audio: 'Subir Audio',
    upload_photo: 'Subir foto de perfil',
    upload_video: 'Subir Video',
    enrolled: 'Inscrito',
    unenroll: 'Des inscribirse',
    from_library: 'Librería multimedia',
    remove: 'Remover',
    removed: 'Removido',
    start_broadcast: 'Iniciar Transmisión',
    end_broadcast: 'Terminar Transmisión',
    camera: 'Cámara',
    screen: 'Pantalla',
    screen_with_camera: 'Pantalla con Cámara'
  },

  card: {
    quick_add: 'Añado rápido',
    add: 'Añadir',
    clone: 'Clonar',
    completed: 'lecciones completadas'
  },

  course: {
    upcoming_course: 'Curso Próximo',
    unPublishEvent: 'Despublicar Evento',
    unPublishAssessment: 'Despublicar Evaluación',
    pastCourse: 'Curso de Entrenamiento',
    upcoming: 'Evento en vivo próximos',
    pastEvent: 'Eventos en vivo pasados',
    pastAssessment: 'Evaluaciones pasadas',
    upcomingAssessment: 'Evaluaciones en vivo próximas',
    created: 'Fecha creada:',
    assignees: 'Cesionarios',
    organisations:
      ' {{ organizaciones }} Organizaciones, <2> {{ usuarios }} usuarios</2>',
    event_date: 'Fecha de evento en vivo <1> {{ fecha }} </1>',
    delete_warning: '¿Está seguro que desea borrar esto?',
    clonning_no_lesson:
      'Por favor añada al menos una lección para clonar el curso.',
    clone_warning: '¿Está seguro que desea clonar esto?',
    clone_success: 'está en proceso de clonación',
    disclaimer: `Yo certifico que mi evaluación no va a:
    - infringir con los derechos de ninguna otra entidad
    - contener ilegalidades incluyendo contenido difamatorio, obsceno, indecente, lascivo, pornográfico, violento, abusivo, insultante, amenazante, o discriminatorio, aunque esté censurado con asteriscos 
    - contener ningún ataque personal a otras personas
    - contener imitaciones de otros participantes, figuras públicas o celebridades
    - contener grabaciones o información personal de ningún individuo sin el consentimiento de dicho individuo y no estará violando ninguna regulación de datos en ninguna parte del mundo
    - contener ninguna solicitación comercial o alguna forma de “spam”'`
  },

  coursecreate: {
    dropzone_text: 'Inserte multimedia',
    sidebar_text: 'Seleccione un tema <1/> para su <3/> lección',
    delete_warning: '¿Está seguro que desea borrar esta lección?'
  },

  coursepage: {
    quizview_loading: 'Verificando respuestas. Por favor espere...',
    quizview_answer: 'Su respuesta'
  },

  coursequiz: {
    title: 'Quizes en todas las lecciones'
  },

  dashboard: {
    tooltip_title: 'No mostrar este video nuevamente',
    page_title: 'Estadísticas de sus cursos',
    page_subtitle: 'Estatus de cursos creados',
    profile_add_info:
      'Añadir su <1>{{uncompleted Text}}</1> para completar su perfil.',
    profile_build:
      'Construir su perfil <1>here</1>, díganos sobre sus intereses y habilidades.',
    profile_title: 'Fuerza de Perfil',
    more_details: 'Más Detalles'
  },

  errors: {
    answer: 'Por favor entre su respuesta',
    answer_correct: 'Seleccione la respuesta correcta',
    code: 'Por favor entre su código',
    criterion: 'Por favor entre criterio',
    duration: 'Duración es requerido',
    element: 'Por favor entre elemento',
    email: 'Por favor entre correo electrónico',
    email_invalid: 'El correo electrónico no es válido',
    feedback_correct: 'Por favor entre el feedback correcto',
    feedback_incorrect: 'Por favor entre el feedback incorrecto',
    host: 'Por favor entre anfitrión del evento',
    host_assessment: 'Por favor entre anfitrión de la evaluación',
    image: 'Por favor suba una imagen',
    location: 'Por favor entre su localización',
    live_location: 'Por favor entre localización de la transmisión',
    limit: 'Por favor entre minutos de transmisión en vivo. ',
    min_3char: '3 caracteres mínimo',
    number: 'por favor entre números positivos.',
    host_email_require: `Correo electrónico del anfitrión es requerido.`,
    attendee_email_require: `Correo electrónico de los asistentes es requerido.`,
    name: 'Por favor entre su nombre',
    not_found_course: 'Curso no fue encontrado',
    not_found_event: 'Evento no fue encontrado',
    not_found_assessment: 'Evaluación no fue encontrada',
    password: 'Por favor entre su contraseña',
    password_digit: 'Al menos un digito',
    password_short: 'Contraseña muy corta, mínimo de 10 caracteres',
    password_special: 'Al menos 1 caracter especial',
    password_uppercase: 'Al menos una letra mayúscula',
    password_lowercase: 'Al menos una letra minúscula',
    phone: 'Por favor entre teléfono',
    phone_invalid: 'Número de teléfono inválido',
    position: 'Por favor entre su posición',
    question: 'Por favor entre pregunta',
    start_date: 'Fecha & Hora de comienzo son requeridos',
    tag: 'Por favor seleccione una etiqueta',
    topics: 'Por favor seleccione al menos un tópico.',
    live_topics: 'Por favor añada tópico',
    title: 'Por favor entre título',
    title_assessment: 'Por favor entre título de evaluación',
    title_course: 'Por favor entre título de curso',
    title_empty: 'El título no puede estar vacío',
    title_event: 'Por favor entre el título del evento',
    title_lesson: 'Por favor entre título de la lección',
    title_quiz: 'Por favor entre nombre del quiz',
    username: 'Por favor entre su nombre de usuario',
    invalid_verification_code: 'Este enlace de verificación ha caducado o ya no es válido. Esto suele ocurrir si se solicitó un correo electrónico de verificación más reciente. Por favor, revisa el correo electrónico más reciente de Sharelook para verificar tu dirección de correo electrónico.',
    upload_error: 'Error – archivo no compatible!',
    upload_more_than_10: 'Solo puede subir un máximo de 10 archivos.',
    topics_max: 'Por favor añada al máximo 3 tópicos .',
    upload_excel: 'Por favor asegúrese que subió el archivo correcto.',
    title_excel: 'Error subiendo plantilla:',
    file_size_exceed: 'Tamaño de archivo fue excedido',
    subtitle_excel:
      'Por favor asegúrese de usar la plantilla prevista y que las columnas estén llenas correctamente.',
    select_broadcast_option:
      'Por favor seleccione una opción para transmitir este evento.',
    multi_hosts_number_error:
      'No. de presentadores no puede exceder al especificado para el evento.',
    conference_people_number_error: `No. de asistentes no puede exceder al especificado para el evento.`,
    select_max_host: 'Seleccione al menos un presentador para el evento.',
    select_max_conference: 'Seleccione al menos un asistente para el evento.',
    stream_stop_error: 'La Transmisión se Detuvo Inesperadamente!',
    unsecure_context:
      'Fatal Error: El navegador de internet no puede tener acceso a la cámara y micrófono por un contexto inseguro. Por favor instale SSL y acceder por https',
    ws_not_supported: 'Fatal Error: WebSocket not supported in this browser'
  },

  events: {
    title: 'Añadir Detalles del Evento en vivo',
    change_host: 'Cambiar Anfitrión',
    finished: 'Este evento ha terminado',
    countdown: 'Evento será transmitido en',
    subtitle:
      'Nombre su evaluación y dígale a su audiencia lo que deben de esperar aprender de ella.',
    poll_disabled: 'El censo no está disponible en este evento',
    disclaimer: `Yo certifico que mi evaluación no va a:
    - infringir con los derechos de ninguna otra entidad
    - contener ilegalidades incluyendo contenido difamatorio, obsceno, indecente, lascivo, pornográfico, violento, abusivo, insultante, amenazante, o discriminatorio, aunque esté censurado con asteriscos 
    - contener ningún ataque personal a otras personas
    - contener imitaciones de otros participantes, figuras públicas o celebridades
    - contener grabaciones o información personal de ningún individuo sin el consentimiento de dicho individuo y no estará violando ninguna regulación de datos en ninguna parte del mundo
    - contener ninguna solicitación comercial o alguna forma de “spam”'`,
    prompt_message:
      'Salir de esta página terminará su evento. ¿Está seguro que desea salir de la página?',
    duration_exceed_message:
      'Su tiempo de transmisión fue excedido, el App va a detener la transmisión.',
    before_schedule_message:
      'Estará por comenzar la transmisión antes de la hora programada. Por favor note que si detiene la transmisión cancelará el evento.',
    browser_unsupportive_message:
      'Su navegador de internet no apoya compartir su pantalla. Puede ver una lista de navegadores apoyados en este enlace.',
    cancel_switch_host_message:
      'El anfitrión no está disponible. El evento continuará de su lado.',
    coaching_prompt_message:
      'No puede salir de esta página hasta que el evento sea finalizado.',
    event_modal_warn: '¿Desea salir de este evento?',
    confirm_message: 'El evento terminará al hacer clic en OK.',
    screen_share_denied: 'A denegado compartir la pantalla',
    media_not_found:
      'La cámara o micrófono no fueron encontrados o no están permitidos en su dispositivo.',
    media_not_access:
      'La cámara o micrófono están siendo usados por otro proceso que no permite leer dispositivos',
    constraint_error:
      'No se encontró ningún dispositivo que se ajusten a sus limitaciones de audio y video. Puede cambiar las limitaciones de audio y video.',
    media_access_denied: 'No está permitido acceder la cámara o micrófono.'
  },

  filters: {
    days7: 'Ultimo 7 días',
    days15: 'Ultimo 15 días',
    days30: 'Ultimo 30 días',
    days365: 'Ultimo 365 días',
    date: 'Fecha creado',
    relevance: 'Relevancia',
    popularity: 'Popularidad',
    name: 'Nombre',
    group: 'Grupo',
    Newest_to_Oldest: 'Mas Nuevo a Mas Viejo',
    Oldest_to_Newest: 'Mas Viejo a Mas Nuevo',
    A_Z: 'A to Z',
    Z_A: 'Z to A'
  },

  helpers: {
    password:
      'Para asegurar la seguridad de su cuenta requerimos que su contraseña tenga al menos una letra minúscula y un número. También necesita tener un mínimo de 10 caracteres de largo.',
    phone:
      'Por favor incluya su código de país de su teléfono, por ejemplo: +65',
    username:
      'Su nombre de usuario será tratado como información pública y compartida con otros usuarios como sea necesario. Por lo tanto, le recomendamos que no use información personal en su nombre de usuario.',
    public_description_normal:
      'Su <0><0/></0> ha sido guardado y es considerado privado por defecto. Esto significa que solamente usted puede ver el contenido. Para publicar este contenido puede seleccionar una de las opciones siguientes. Publicar el curso en público significa que será disponibles a todos los usuarios de la plataforma. La Opción de Usuario Específico le permitirá compartir su curso con usuarios específicos utilizando el correo electrónico que tienen asociado con su cuenta de Sharelook.',
    public_description_admin:
      'Esta <0><0/></0> ha sido guardada y es considerada privada por defecto. Esto significa que solamente usted (y el creador del contenido) pueden ver el contenido. Para publicar este contenido puede seleccionar una de las siguientes opciones. Publicar su curso al público significa que estará disponible a todos los usuarios de la plataforma incluyendo aquellos fuera de su organización. Publicarlo a la organización significa que todos los usuarios de la organización podrán acceder el curso. También puede publicarlo a 1 o más grupos, significando que solo los usuarios dentro de dichos grupos podrán acceder el curso. Finalmente, tiene la opción de publicar para usuarios específicos dentro y fuera de su organización usando el correo electrónico asociado con sus cuentas de Sharelook.'
  },

  labels: {
    add: 'Añadir',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'Answer type',
    answers: 'Contestaciones',
    back_to_quiz: 'Regresar a lista de Quiz',
    back_to_question: 'Regresar a lista de preguntas',
    chat: 'Chat',
    chat_available: 'Chat no está disponible en este evento',
    chat_report: 'Chat Report',
    choice_single: 'Elección única',
    choice_multiple: 'Elección multiple',
    choice_free: ' Elección "Libre"',
    choice_sorting: 'Elección "Ordenación"',
    choice_matrix: 'Elección "Ordenación de matriz "',
    clone_lesson_permission: 'Permiso de clonar',
    code: 'Código',
    correct: 'Correcto',
    created: 'Fecha creado',
    clone_modal: 'Clonar curso',
    cloning_course: 'Clonando curso...',
    cloning: 'Clonando...',
    cloning_course_desc:
      'Este proceso tomará unos minutos. Por favor tenga paciencia.',
    cloning_success: 'Curso "<0/>" ha sido clonado exitosamente!',
    description: 'Descripción',
    disclaimer: 'Disclaimer',
    drop_file: 'Suelte archivo aquí...',
    duration: 'Duración',
    edit: 'Editar',
    email: 'Correo Electrónico',
    event: 'Evento',
    event_all: 'Todos sus Eventos',
    event_date: 'Fecha/Hora Local del Evento',
    event_this: 'Este Evento',
    expire: 'Expira en',
    expiry_date: 'Fecha de expiración',
    forgot: '¿Se le olvidó la contraseña?',
    group: 'Grupo',
    groups_list: 'Lista de grupos',
    host: 'Anfitrión',
    id_annotation: 'id de anotación',
    id_quiz: 'Quiz id',
    incorrect: 'Incorrecto',
    interests: 'Intereses',
    invited: 'Invitado',
    live_chat: 'Discusión en vivo',
    live_stream_limit: 'Minutos de transmisión en vivo',
    contact_text:
      'Para cambiar su límite mensual de transmisión por favor contacte',
    contact_admin:
      '<0>Si desea cambiar su límite de transmisión por favor contacte</0> <1>admin@sharelook.com</1>',
    limit_stream_text:
      'Minutos de transmisión en vivo restantes: <0>{{ limit }}</0> minutos <1/><2/> <3> Para cambiar su límite mensual de transmisión por favor contacte </3> <4>admin@sharelook.com</4>',
    location: 'Localización',
    lessons: 'Lecciones',
    location_broadcast: 'Host Server Location',
    location_broadcast_subtitle:
      'Añada una localización que sea cercana a la transmisión del anfitrión para reducir demoras audiovisuales.',
    media_manager: 'Manager de Multimedia',
    minutes: 'Minutos',
    name: 'Nombre',
    online_quiz: 'Online Quiz',
    organiser: 'Autor',
    organization: 'Organización',
    overall_emotion: 'Experiencia General:',
    organizations_list: 'Lista de Organizaciones',
    password: 'Contraseña',
    participants: 'Participantes',
    picture: 'Picture',
    phone: 'Teléfono',
    photo: 'Foto',
    poll: 'Censo',
    position: 'Posición',
    processing: 'Procesando',
    privacy_settings: 'Ajustes de Privacidad',
    question: 'Pregunta',
    quiz_create: 'Crear Quiz Nuevo',
    quiz_name: 'Nombre de Quiz',
    quiz_update: 'Actualizar quiz',
    select_organization: 'Selecciona una organización',
    settings: 'Ajustes',
    show: 'Show',
    show_graph: 'Show graph result',
    signin: 'Inicio',
    signup: 'Inscribirse',
    sort_by: 'Ordenar por',
    start_date: 'Fecha de comienzo',
    tags: 'Tags',
    terms: 'Estoy de acuerdo con estos <1>términos y condiciones</1>.',
    title: 'Título',
    topics: 'Tópicos',
    topic: 'Tópico',
    total_comments: 'Total Comentarios',
    username: 'Nombre de usuario',
    users_list: 'Lista de usuarios',
    users_emails:
      'Inserte los correos eléctronicos de sus usuarios específicos',
    description_specifiction_email:
      'Por favor entre 1 correo electrónico por línea para compartir con múltiples usuarios específicos.',
    message_specific_email: 'Por favor entre el email del usuario específico.',
    viewers: 'Espectadores',
    edit_course: 'Editar',
    edit_assessment: 'Editar',
    edit_event: 'Editar',
    delete_course: 'Borrar',
    delete_event: 'Borrar',
    delete_assessment: 'Borrar',
    view_course: 'View',
    view_event: 'View',
    view_assessment: 'View',
    date_event: 'Fecha de evento en vivo',
    date_assessment: 'Fecha de evaluación en vivo',
    clone_of: 'Clonar',
    clone_course:
      'Cree un clon de este curso que le permita modificar independientemente del original, incluye todas las lecciones y páginas.',
    make: 'Crear',
    available_to: 'disponible para cualquier usuario de ShareLook',
    uploaded_by: 'Subido por: ',
    course: 'Curso',
    assessment: 'Evaluación',
    user_not_exist: 'El usuario no existe, ¿le gustaría enviar una invitación?',
    check_user: 'Noticia',
    user_not_exist_in_org:
      'El usuario no existe en esta organización, ¿le gustaría enviar una invitación?',
    title_modal_stream:
      'Cambiar el Límite de Transmisión en Vivo de la Organización',
    des_warning_stream: 'Esta por cambiar',
    monthly_stream: 'límite de transmisión en vivo mensual:',
    min_per_month: 'mins/mes',
    broadcast_label: 'Yo quiero hacer:',
    hosts_emails: `Añada correo electrónico específico de anfitriones`,
    attendee_emails: `Añada correo específico de asistentes`,
    description_host_specifiction_email:
      'Por favor entre 1 correo electrónico por línea.',
    presenter_label: 'Presentador',
    presenter_label_conference: 'No. de Personas',
    event_privacy: 'Modo de Conferencia'
  },

  broadcastOptions: {
    stream_from_phone: 'Transmisión en vivo con mi teléfono',
    other_webrtc: 'Webinar desde mi PC',
    multihost: 'Multidifundir webinar desde mi PC',
    peer2peer: 'Sesión de Coaching',
    conference: 'Conferencia en Vivo'
  },

  lessoncreate: {
    title: 'Añadir detalles de la lección',
    subtitle:
      'Nombre su lección y dígale a su audiencia lo que deben esperar aprender de ella.',
    input_label_title: 'Título de la lección',
    input_label_topics: 'Tópicos de la lección',
    input_label_description: 'Descripción de la lección',
    delete_warning: '¿Esta seguro que desea borrar esta página?'
  },

  lessonoverview: {
    title: 'Anadir lección',
    subtitle: 'Añadir lección existente o crear una nueva',
    new_lesson: 'crear una nueva lección',
    new_lesson_sub: 'Crear una nueva lección desde cero!',
    existing_lesson: 'Seleccione una lección existente',
    existing_lesson_sub:
      'Enlace a una lección existente, los cambios hechos en esta lección también afectaran esta lección en otros cursos.',
    clone_lesson: 'duplicar lección existente',
    clone_lesson_sub:
      'Cree una copia única de la lección en este curso, cambios hechos a esta lección no afectaran la lección original.',
    clone_lesson_modal_sub:
      'Por favor haga clic en el botón de clonar debajo de la lección que quiera añadir a su curso.'
  },

  management: {
    groups_title: 'Manejar Grupos',
    delete_warning: '¿Está seguro?',
    organizations_title: 'Mi Organización',
    organizations_subtitle: 'Añadir organizaciones a su lista',
    users_title: 'Manejar Usuarios',
    users_position: 'Senior Account Manager',
    user_not_found: 'El usuario no fue encontrado',
    select_org:
      'Por favor busque y seleccione una organización para manejar usuarios'
  },

  audio: {
    modal_title: 'Añadir Audio',
    list_view: 'List View',
    create_audio_modal_title: 'Crear Audio',
    edit_audio_modal_title: 'Editar Audio',
    public_audio_not_found: 'Audio no fue encontrado.',
    private_audio_not_found: 'Todavía no ha subido ningún audio',
    are_you_sure_to_delete: '¿Está seguro que quiere borrar?',
    type_something: 'Escriba algo',
    select_voice: 'Seleccione',
    file_name: 'Nombre de Archivo',
    description: 'Descripción',
    topic: 'Tópico',
    key_words_tag: 'Tag de palabras claves',
    mp3_audio: 'MP3 Audio',
    created: 'Creado',
    duration: 'Duración',
    close: 'cerrar'
  },

  image: {
    modal_title: 'Añadir imagen',
    image: 'Imagen',
    pixel: 'Pixel',
    dimension: 'Dimension',
    public_image_not_found: 'Imagen no fue encontrada.',
    private_image_not_found: 'Todavía no ha subido ninguna imagen'
  },

  annotation: {
    modal_title: 'Annotation'
  },

  text: {
    modal_title: 'Text Editor'
  },

  video: {
    modal_title: 'Añadir Video',
    image: 'Video',
    mp4_video: 'MP4 Video',
    public_video_not_found: 'Video no fue encontrado.',
    private_video_not_found: 'Todavía no ha subido ningún video.'
  },

  media: {
    title: 'Librería Multimedia',
    subtitle: 'Librería de sus Archivos',
    modal_title: 'Subir media',
    delete_warning: 'Confirmar Borrar',
    delete_message:
      'La multimedia que eliminó aun aparecerá en aquellas páginas que ya fueron utilizadas',
    dropzone_text: 'Arrastrar y soltar',
    delete_success: 'Media fue borrada exitosamente',
    upload_file: 'Subir Archivo',
    drag_drop: 'o Arrastrar y soltar',
    import_file: 'Añadir archivos de su computadora',
    no_media: 'Todavía no ha añadido ningún multimedia',
    media_type: 'Media type',
    video: 'Video',
    image: 'Imagen',
    audio: 'Audio',
    gif: 'GIF',
    transcribed_text: 'Transcribed Text',
    media_not_found: 'Media no se encontró.',
    of: 'de',
    disclaimer: ` Yo certifico que mi evaluación no va a:
    - infringir con los derechos de ninguna otra entidad
    - contener ilegalidades incluyendo contenido difamatorio, obsceno, indecente, lascivo, pornográfico, violento, abusivo, insultante, amenazante, o discriminatorio, aunque esté censurado con asteriscos 
    - contener ningún ataque personal a otras personas
    - contener imitaciones de otros participantes, figuras públicas o celebridades
    - contener grabaciones o información personal de ningún individuo sin el consentimiento de dicho individuo y no estará violando ninguna regulación de datos en ninguna parte del mundo
    - contener ninguna solicitación comercial o alguna forma de “spam”'`
  },

  navigation: {
    account: 'Cuenta',
    assessments: 'Evaluaciones',
    dashboard: 'Dashboard',
    groups: 'Manejo de Grupo',
    logout: 'Log out',
    organisations: 'Organizaciones',
    organizations_users: 'Organizaciones & Usarios',
    reports: 'Reportes',
    schedule: 'Itinerario',
    training: 'Entrenamiento',
    nowLive: 'Transmitir',
    users: 'Usarios',
    workshop: 'Mi Taller'
  },

  onboarding: {
    step1_title: 'Paso 1 : Díganos un poco acerca de usted',
    step1_subtitle: '¿Cuál es su nombre? ¿De dónde es? ¿Cuál es su profesión?',
    step2_title:
      'Paso 2 : Selecciona alguna habilidad que necesites o puedas mejorar',
    step2_subtitle:
      'Próximo, díganos que le gustaría entender mejor. ¿Quizás algo que aún no has aprendido? ¿Un nuevo campo de estudio? ¿Lo que hacen tus seres queridos?'
  },

  pagebuilder: {
    title: 'Crear Lección',
    subtitle:
      'Es tiempo de crear el contenido para que su audiencia aprenda de usted, puede usar fotos, videos o gráficas.',
    select_layout: 'Seleccione un diseño de página',
    template1: 'Blank',
    template2: 'Título y subtitulo',
    template3: 'Título & Texto',
    template4: 'Título, Media & Texto',
    template5: 'Título & Media',
    template6: 'Título & Quiz'
  },

  pageconstructor: {
    title: 'Crear Y Clonar Lección',
    subtitle:
      'Es tiempo de crear el contenido para que su audiencia aprenda de usted, puede usar fotos, videos o gráficas.'
  },

  passwordreset: {
    success_coded:
      'Hemos enviado un código de confirmación a la dirección provista, por favor copie el código en el campo debajo para programar una nueva contraseña.',
    success_changed:
      'A programado una nueva contraseña exitosamente. Ahora puede entrar al sistema.'
  },

  placeholders: {
    search: 'Buscar',
    answer: 'Contestación',
    chat: 'Decir algo...',
    code: 'Código',
    criterion: 'Criterio',
    date_event: 'Seleccione Fecha y Hora',
    date_start: 'Fecha de comienzo',
    date_expire: 'Fecha de expiración',
    description: 'Descripción',
    elements: 'Sort elements',
    email: 'Correo Electrónico',
    feedback_correct: 'Feedback Correcto',
    feedback_incorrect: 'Feedback Incorrecto',
    host: 'Anfitrión',
    keywords: 'Search keyword(s)',
    lesson_description: 'Descripción de la lección',
    location: 'Localización',
    minutes: 'Minutos',
    name: 'Nombre',
    organiser: 'Autor',
    organization: 'Organización',
    password: 'Contraseña',
    phone: 'Teléfono',
    photo: 'Foto',
    picture: 'Imagen',
    point: 'Punto',
    position: 'Posición',
    question: 'Pregunta',
    quiz: 'Nombre de Quiz',
    search_course: 'Buscar por curso',
    search_media: 'Buscar media',
    search_name: 'Buscar por Nombre',
    search_title: 'Buscar por título',
    search_training: 'Buscar entrenamiento',
    settings: 'Ajustes',
    tags: 'Tags',
    title: 'Título',
    topics: 'Tópicos',
    username: 'Nombre de Usuario',
    keyword: 'Palabras clave',
    max_500_characters: 'Max 500 Caracteres ',
    no_description: 'Este archivo no tiene una descripción',
    no_keyword: 'Este archive no tiene palabras claves',
    no_topics: 'Este archive no se le ha puesto un tópico',
    feedback: 'Mensaje',
    contact: '¿Cómo podemos ayudar?'
  },

  publishsettings: {
    title: 'Publicar Ajustes',
    event_subtitle:
      'Añada ajustes a su evento, quién puede ver e interactuar con su evento',
    assessment_subtitile:
      'Nombre su evaluación y dígale a su audiencia lo que deben esperar aprender de ella.',
    course_subtitle:
      'Añada ajustes a su curso, quién puede ver e interactuar con su curso',
    disclaimer: ` 1. Registración

  Al registrarse como un usuario o al crear una cuenta usted está de acuerdo con nuestro [User Agreement] y reconoce haber leído nuestra [Privacy Policy]

  2.	Crear Curso

  Al usar nuestras herramientas y desarrollar contenido de curso, usted está de acuerdo con nuestro [User Agreement] y reconoce haber leído nuestra [Privacy Policy]

  3.	Crear evento

  Al usar nuestras herramientas y desarrollar contenido de curso, usted está de acuerdo con nuestro [User Agreement] y reconoce haber leído nuestra [Privacy Policy]

  4.	Crear evaluación

  Al usar nuestras herramientas y desarrollar contenido de curso, usted está de acuerdo con nuestro [User Agreement] y reconoce haber leído nuestra [Privacy Policy] `,
    dates_validation_error: 'Ambas fechas deben existir.',
    course_dates_validation_error: 'Ingrese la fecha de inicio y finalización de este curso.',
    emails_validation_error: 'Lista de correos es inválida.',
    specific_email_validation_error:
      'Solamente se permite un correo electrónico.',
    i_agree_to_these: 'Estoy de acuerdo con estos ',
    terms_and_conditions: 'términos y condiciones.',
    PublicDescription:
      'Usuarios independientes gratis: (opciones privadas y públicas) Su [Curso|Evento|Evaluación] ha sido guardado y es considerado privado por defecto. Esto significa que solo usted puede ver este contenido. Para publicar el contenido puede seleccionar hacerlo público abajo. Esto significa que curso estará disponible para todos los usuarios de la plataforma.',
    OrganisationsDescription:
      'Usuarios de Org: (En vez de ""Finalizar"" use ""Publicar"" y tráigalos a la página de publicación igual que a otros usuarios pero sin ninguna de la opciones de publicación.) Su [Curso|Evento|Evaluación] ha sido guardado y es privado. Esto significa que solo usted y los Administradores en su organización pueden verlo. Como un usuario, no puede publicar su contenido dentro de la organización ya que esto requiere derechos de administrador. Por favor contacte uno de sus administradores y pida que publiquen su contenido públicamente a toda la organización, a grupos específicos dentro de su organización o a usuarios específicos.',
    OrganisationGroupsDescription:
      'Org Admins: (Para contenido hecho dentro de la organización: Privado, público, organización, usuario específico): Este [Curso|Evento|Evaluación] ha sido guardado y es considerado privado por defecto. Esto significa que solo usted (y el creador del contenido) pueden ver este contenido. Para publicar este contenido puede seleccionar una de las siguientes opciones. Publicar su curso al público significa que estará disponible a todos los usuarios de la plataforma incluyendo aquellos fuera de su organización. Publicarlo a la organización significa que todos los usuarios de la organización podrán ver el contenido. También puede publicar a 1 o más grupos, significando que solo los usuarios dentro de esos grupos podrán ver el curso. Finalmente, tiene la opción de publicar a usuarios específicos dentro o fuera de su organización usando sus correos electrónicos asociados con la cuenta de Sherlook.',
    SpecificUsersDescription:
      'Usuarios Independientes pagados: (privados, públicos y específico) Su [Curso|Evento|Evaluación] ha sido guardado y es considerado privado por defecto. Esto significa que solo usted puede ver este contenido. Para publicar este contenido puede seleccionar una de las siguientes opciones. Publicar su curso al público significa que estará disponible a todos los usuarios de la plataforma. La opción de Usuario Específico le permitirá compartir su curso con usuarios específicos usando sus correos electrónicos asociados con sus cuentas de Sharelook.'
  },

  quiz: {
    quiz_empty: 'Todavía no ha creado un quiz',
    questions_empty: 'Todavía no ha creado una pregunta'
  },

  regions: {
    asia_pacific_australia: 'Australia',
    asia_pacific_india: 'India',
    asia_pacific_japan: 'Japan',
    asia_pacific_s_korea: 'South Korea',
    asia_pacific_singapore: 'Singapore',
    asia_pacific_taiwan: 'Taiwan',
    eu_belgium: 'Belgium',
    eu_germany: 'Germany',
    eu_ireland: 'Ireland',
    south_america_brazil: 'Brazil',
    us_central_iowa: 'Iowa',
    us_east_s_carolina: 'South Carolina',
    us_east_virginia: 'Virginia',
    us_west_california: 'California',
    us_west_oregon: 'Oregon'
  },

  reports: {
    title: 'Reportes'
  },

  signup: {
    success_step1:
      'Hemos enviado un código de confirmación a la dirección provista, por favor copie el código en el campo debajo para programar una nueva contraseña ',
    success_step2: 'Gracias. Está registrado exitosamente.',
    privacy: `Estoy de acuerdo con Sharelook's <1> términos & condiciones</1> and <3> privacy policy</3>`
  },

  stream: {
    emotion_impressive: 'Impresionante',
    emotion_unimpressive: 'No impresionante',
    message_not_started: 'Pronto',
    message_running: 'En Vivo',
    message_processing:
      'Estamos procesando la grabación en vivo para ser reproducida. Por favor verifique más tarde para poder ver el video y para continuar añadiendo ratings y feedback.'
  },

  tabs: {
    audience: 'Audiencia',
    course: 'Visión del Curso',
    details: 'Detalles del Evento en Vivo',
    description: 'Descripción',
    host: 'Anfitrión',
    lesson: 'Visión de la Lección',
    lessons: 'Lecciones',
    overview: 'Visión',
    page: 'Constructor de Página',
    publish: 'Publicar',
    settings: 'Ajustes de Publicación',
    total_views: 'Total Views',
    live_participates: 'Participantes en Vivo',
    live_chats: 'Chats en Vivo',
    live_quiz: 'Censo en Vivo',
    trainer_rating: 'Rating del Entrenador',
    trainer_times: 'Tiempo del Entrenador',
    courses_quizzes: 'Quizzes del Curso',
    user_list: 'Lista de Usuario',
    discussion: 'Discusión',
    notes: 'Mis Notas'
  },

  topics: {
    SALES_TRAINING: 'Entrenamiento de Ventas',
    NEGOTIATION_TRAINING: 'Entrenamiento de negociaciones',
    CROSS_CULTURAL_AWARENESS: 'Conciencia Intercultural',
    NETWORKING_SKILLS: 'Habilidades de Networking',
    SOFTWARE_ARCHITECTURE: 'Arquitectura de Software',
    PROJECT_MANAGEMENT: 'Gestión de Proyectos',
    DIGITAL_TRANSFORMATION: 'Transformación Digital',
    IT_CONSULTING: 'Consultoría de IT',
    MANAGEMENT_CONSULTING: 'Consultoría de Gerencia',
    HR_CONSULTING: 'Consultoría de HR',
    INTERNET_OF_THINGS: 'Internet of Things (IoT)',
    CYBERSECURITY: 'Cybersecurity',
    PRIVACY_AND_GDRP: 'Privacy and GDPR'
  },

  training: {
    title: 'Entrenamiento',
    title_assessment: 'Evaluaciones',
    subtitle: 'Cursos y Eventos en Vivo',
    enrolled_title: 'Cursos y Eventos Inscritos',
    enrolled_subtitle: 'Cursos y Eventos en los que se ha inscrito',
    enrolled_message: 'Actualmente no está inscrito en ningún curso o evento.',
    past_live_event_title: 'Eventos En Vivo Pasados',
    past_live_event_subTitle: 'Eventos En Vivo Terminados',
    past_live_event: 'Actualmente no hay eventos pasados.',
    recomended_title: 'Cursos y Eventos Recomendados',
    now_live_event_title: 'Ahora En Vivo',
    now_live_event_subTitle: 'Eventos que están en vivo o estarán muy pronto',
    now_live_event: 'Actualmente no hay evento en vivo.',
    webinar_event_title: 'Canal Webinar',
    webinar_event_subTitle: 'Webinars Terminados',
    webinar_event: 'Actualmente no hay webinar.',
    p2p_event_title: 'Sesiones de Coaching',
    p2p_event_subTitle: ' Sesiones de Coaching Terminadas',
    p2p_event: 'Actualmente no hay sesiones de coaching.',

    now_live_assessment_title: 'Ahora en vivo',
    now_live_assessment_subTitle:
      'Evaluaciones que están en vivo o estarán muy pronto',
    now_live_assessment_message: 'Actualmente no hay evaluaciones en vivo',

    upcoming_assessment_title: 'Próximas Evaluaciones en Vivo',
    upcoming_assessment_subtitle: 'Próximas Evaluaciones en Vivo',
    upcoming_assessment_message: 'Actualmente no hay evaluaciones próximas.',

    past_live_assessment_title: 'Evaluaciones En Vivo Pasadas',
    past_live_assessment_subTitle: 'Evaluaciones Terminadas',
    past_live_assessment_message: 'Actualmente no hay evaluaciones pasadas',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
      'Hemos seleccionado cursos y eventos en vivo basados en su <0><0/></0>',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'Buscar Entrenamiento',
    search_assessment: 'Buscar Evaluaciones',
    recomended_message: 'Actualmente no hay cursos o eventos recomendados.'
  },

  warnings: {
    delete: '¿Está seguro?'
  },

  workshop: {
    title: 'Mi Taller',
    subtitle: 'Crea tu propio cuso o evento en vivo',
    new_course: 'Crea un nuevo curso',
    new_event: 'Crea un nuevo evento',
    new_assessment: 'Crea una nueva evaluación en vivo',
    courses_title: 'Cursos y Evaluaciones en Vivo Creadas',
    courses_subtitle: 'Editar & Publicar sus cursos y planear eventos en vivo',
    tags_course: 'Curso',
    tags_live: 'Evento en vivo',
    tags_assessment: 'Evaluación en vivo'
  },

  help_center: {
    sidebar: {
      title: '¿Cómo Podemos ayudarlo?',
      back_to: 'Dashboard'
    },
    menu: {
      help_center: 'Centro de Ayuda',
      whats_new: "What's new",
      feedback: 'Feedback',
      feedback_title: 'Enviar feedback para sharelook',
      terms_and_conditions: 'Términos & Condiciones',
      privacy_policy: 'Privacy Policy',
      contact_us: 'Contáctanos'
    },
    get_started: {
      title: 'Empezando con share look',
      description: {
        main:
          'HEMOS INTEGRADO VIDEO EN VIVO DENTRO DE UN CONSTRUCTOR DE CURSO QUE ES FACIL DE UTILIZAR.',
        tagline:
          'Con el sistema patentado de ShareLook, podrá crear compromisos, aprendizajes automatizados y maximizar la distribución del conocimiento.'
      }
    },
    whats_new: {
      title: 'Empezando con share look',
      description: {
        main:
          'Sabía usted que un aprendizaje estilo narrativo puede ser creado en una poca cantidad de tiempo y no es costoso?  Debería combinar el constructor de curso de ShareLook y los talentos respectivos. Pregúntenos "COMO',
        tagline: ''
      }
    },
    create_workshop: 'Cómo Crear un Taller',
    create_course: 'Cómo Crear un Curso',
    create_user: 'Cómo Crear un Usuario',
    create_group: 'Cómo Crear un Grupo',
    create_webinar: 'Cómo Crear un Webinar',
    create_live_event: 'Cómo Crear un Evento en Vivo',
    create_live_assessment: 'Cómo Crear una Evaluación en Vivo',
    create_live_on_mobile: 'Crear en Vivo en Mobil',
    personalize_profile: 'Personificar el Perfil',
    manage_group: 'Manajar Grupos',
    report: 'Reportes',
    add_annotations: 'Cómo Añadir Anotaciones Popups',
    add_audio: 'Cómo Añadir Audio',
    add_header_and_footer: 'Añadir Header & Footer',
    add_image: 'Cómo Añadir Imagen',
    add_quiz_content: 'Cómo Añadir Contenido de Quiz',
    add_text_content: 'Cómo Añadir Contenido de Texto',
    add_user: 'Cómo Añadir Usuario',
    add_video: 'Cómo Añadir Video',
    clone_course: 'Cómo Clonar el Curso',
    find_live_broadcast: 'Cómo Encontrar Transmisiones en Vivo',
    contact_us: {
      title: 'Contactenos',
      subject_placeholder: 'Entre un tema*',
      content_placeholder: 'Entre mensaje*',
      subject_required: '*Tema es requerido',
      content_required: '*Mensaje es requerido',
      submit: 'Enviar',
      cancel: 'Cancelar',
      sent: 'Enviado'
    },
    feedback: {
      title: 'Enviar feedback para sharelook',
      attach_title: 'Añada Archivo',
      choose: 'Escoja un archivo',
      detail: 'El archive será compartido con el equipo de soporte',
      content_placeholder: 'Enter a message*',
      content_required: '*Message is required',
      submit: 'Enviar',
      cancel: 'Cancelar',
      sent: 'Enviado'
    }
  },
  discussion: {
    join_discussion: 'Join in discussion'
  },
  notes: {
    title: 'Mis Notas',
    add_note: 'Añadir nueva nota'
  }
}
